import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  ViewRef
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '../../../../formbird-services/src/lib/services/config/config.service';
import {SearchResultsProcessor} from '@formbird/shared';
import {SelectedAssetComponentDefinition} from './selected-asset.component.definition';
import {SclMappingFunctionsService} from '../../../../formbird-mapping/src/lib/scl-mapping-functions.service';
import {sclHandlebars} from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclAssetLayersService} from '../../../../formbird-mapping/src/lib/scl-asset-layers.service';
import {SclMapViewsService} from '../../../../formbird-mapping/src/lib/scl-map-views.service';
import {HttpService} from '../../../../formbird-mapping/src/lib/http.service';
import {FormbirdInjectorService} from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import {MatTooltip} from '@angular/material/tooltip';
import {MatFormField} from '@angular/material/form-field';

import {isEqual, cloneDeep, find, isNumber, isArray, isString} from 'lodash';
import * as $ from 'jquery';
import {SearchService} from '../../../../formbird-services/src/lib/services/search/search.service';
import {NotificationService} from '../../../../formbird-services/src/lib/services/notification/notification.service';
import {ChangedDocumentService} from 'formbird-services';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { SclSearchClientConstantService } from '@formbird/services';
import { AddressDetails } from '../../../../formbird-mapping/src/lib/AddressDetails';
import { MapLibraryName, MapComponentName
, MapSelectAssetMode, MapSelectAssetType, MapDrawType, 
GEOJSON_TYPE,
FEATURE_TYPE} from '../../../../formbird-mapping/src/lib/map-library';


export interface AssetPolygon {
  _index: string;
  _type: string;
  _id: string;
  _score: number;
  _source: {
    systemHeader: {
      summaryName: string;
      createdDate: string;
    },
    gblBoundaryTestDocument: {
      type: string;
      features: [
        {
          geometry: {
            coordinates: any;
            type: string;
          },
          type: string;
          properties: any;
        }
      ]
    },
    documentId: string
  };
}

@Component({
  templateUrl: './selected-asset.component.html',
  styleUrls: [
    './selected-asset.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedAssetComponent extends AbstractComponent<SelectedAssetComponentDefinition> implements OnInit, AfterViewInit, OnChanges {


  @Input() responsiveLayouts: string;

  @Input() get assetsPrimary() {
    return this.sAssetsPrimary;
  }
  set assetsPrimary(value) {
    // begin $watch('assets.primary)
    if (!this.isLoadSavedDocument) {
      this.addHeader();
      this.updateValue();
    }
    this.isDocFieldValueChanged = false;
    this.sAssetsPrimary = value;
    this.assets.primary = JSON.parse(this.sAssetsPrimary);
    this.setPrimaryScrollView();
    // end $watch('assets.primary)

    this.cdRef.detectChanges();
  }
  @Input() get assetsSecondary() {
    return this.sAssetsSecondary;
  }
  set assetsSecondary(value) {
    // begin $watch('assets.secondary)
    if (!this.isLoadSavedDocument) {
      this.addHeader();
      this.updateValue();
    }
    this.isDocFieldValueChanged = false;
    this.sAssetsSecondary = value;
    this.assets.secondary = JSON.parse(this.sAssetsSecondary);
    this.setSecondaryScrollView();
    // end $watch('assets.secondary)

    this.cdRef.detectChanges();

  }




  @Input() fieldValues: any[];
  @Input() showInPrint: any;
  @ViewChild('tooltipInfo', { static: false }) tooltipInfo: ElementRef;
  @ViewChild('radioPopupInfo', {static: false}) radioPopupInfo: ElementRef;
  @ViewChild('clusterPopupInfo', {static: false}) clusterPopupInfo: ElementRef;
  @ViewChild('info', {static: false}) divInfo: ElementRef;
  @ViewChild('info1', {static: false}) divInfo1: ElementRef;
  @ViewChild('infoCluster', {static: false}) divInfoCluster: ElementRef;
  @ViewChild('dvPrimarySelection', {static: false}) dvPrimarySelection: ElementRef;
  @ViewChild('dvSecondarySelection', {static: false}) dvSecondarySelection: ElementRef;
  @ViewChild('mapWrapper', {static: false}) mapWrapper: ElementRef;

  // service
  loggedInUserService: any;
  fileProviderService: any;
  unsavedDocumentService: any;
  searchClientService: any;

  mapFunc;
  addressMarker = SclMapConstantService.MAP_MARKER;
  fullWidthClass = 'sc-selected-asset-fullwidth';  // removed class col-xs-12

  // scope
  scope: {[k: string]: any} = {};
  results = {};
  current = null;
  timeDelay = 1000;
  noSecondaryAssetSelection = true;
  resultsPrimary = [];
  resultsSecondary = [];
  mapId;
  currentPrimary; currentSecondary;
  assets = {
      primary: [],
      secondary: []
  };

  private sAssetsPrimary = ''; private sAssetsSecondary = '';

  debounce = SclMapConstantService.DEFAULT_SEARCH_DELAY;
  searchMinLength;
  addressLookupId;
  unitNoId;
  streetNoId;
  streetNameId;
  suburbTownId;
  stateId;
  countryId;
  postCodeId;
  addrDescriptionId;
  latitudeId;
  longtitudeId;
  primaryAssetId;
  secondaryAssetId;
  isGoogleGeocodeService = false;
  hideAddress = false;
  templatePopover = 'popoverScript1.html';  // "popoverScriptTooltip.html";
  toolTipZIndex = 100;
  isGoogleMap;
  //
  isEditable; isSecondaryAsset; isPrimaryAsset;
  primaryAssetSelectionMode = MapSelectAssetMode.POINT;
  secondaryAssetSelectionMode = MapSelectAssetMode.POINT;
  primaryAssetSelection = { selectionImageFileNo: null, selectionImageAnchor: null, selectionRows: null
  , selectionImageAnchorHandlebars: null, selectionImageRotation: 0, selectionImageRotationHandlebars: null
  , selectionColor: null, selectionFill: null, selectionFillOpacity: null, selectionFillOpacityHandlebars: null
  , selectionLineCap: null, selectionLineDash: null, selectionLineWidth: null };
  secondaryAssetSelection = { selectionImageFileNo: null, selectionImageAnchor: null, selectionRows: null
  , selectionImageAnchorHandlebars: null, selectionImageRotation: 0, selectionImageRotationHandlebars: null
  , selectionColor: null, selectionFill: null, selectionFillOpacity: null, selectionFillOpacityHandlebars: null
  , selectionLineCap: null, selectionLineDash: null, selectionLineWidth: null };
  primaryAssets = []; secondaryAssets = [];
  assetSelectionsAvailable = [];
  centerOnReverse = false;
  zoomFloor;
  singlePrimaryAssetSelection = false; singleSecondaryAssetSelection = false;
  geoJsonField = '';
  maxItems;
  point;
  disableMouseWheel = false;
  mapSource;
  mapParameters;
  timeOutDelay = 1000;
  vectorLayer;
  snap;
  primaryIcon = SclMapConstantService.MAP_PRIMARY_ASSET;
  secondaryIcon = SclMapConstantService.MAP_SECONDARY_ASSET;
  secondaryImageAnchor; primaryImageAnchor; addressImageAnchor;

  positionMandatory;
  geocodeSearchService = [];
  apiKey;
  geocodeURL = 'https://www.geocode.farm/v3/json/reverse/';
  popupAssetSelection = false;

  initialAssetLoading = true; // 14870 & 20075#c92132 & 20117: true, 14870#c62660: false
  initialAssetLoadArc = true; // 15058#c57166
  selection = [];
  isDocFieldValueChanged = false;
  // test redraw layer
  layersRedraw = false;
  // geo-auto-complete component
  autoCompleteBox;
  isComponentReady = false;
  postList: any = [];
  disablePopupOkButton;
  buttonInPopover;
  visible = true;
  primarySelectionRows = 0;
  secondarySelectionRows = 0; // 14327
  bodyRect = document.body.getBoundingClientRect(); // 14327
  preAssetText = '';
  inputText = '';
  queryDelay = 5; // 14465
  searchZoom; hasAddressPin = false; // 14479#0053120 ( just use for comp-dev )
  lookupAddressForPrimaryAsset = false; lookupAddressForSecondaryAsset = false; latestAssetId; // 14502 ( just use for comp-dev )
  initialMapView = []; isUpdateViewPort = false; // 14781
  keyName;
  clickPoint;
  mapLibName = MapLibraryName.OPEN_LAYER;
  mapGeo;
  controls = [];
  layerIds = [];
  primarySelection;
  secondarySelection;
  checkSpanPrimary;
  spanPrimarySelection;
  checkSpanSecondary;
  spanSecondarySelection;
  totalHeight = 0;
  documentOldValue;
  isLoadSavedDocument;
  isMapReady; // 14781#c55330
  hasSelectedAsset = false;
  moveToSelectedSearchAsset = false; // 15262
  isRadioPopupScroll; // 15336
  intervalToolTipSetup = null; countIntervalTooltipSetup = 0; hasCustomControl = false; // 15336#c59379
  primaryAssetAddressLookup = false; primaryAssetAddressLookupRadius = 50; primaryAssetAddressLookupTimeout = 60; // 15393
  primaryAssetAddressLookupPoint = 'assetCentre'; primaryAssetAddressLookupClickPoint; // 15393
  isClusterPopupScroll; clusterList: any = []; clusterMarkersClicked = []; allowSelectAsset; // 15251
  resizeTime; resizeTimeout = false; resizeThreshold = 250;
  hasMapWheelScroll = false; // 15973
  geoRelatedDocuments; // 14881
  nonSelectVisualItemCounter;
  searchAssetSelectionInclude = false;
  drawSelectAssetUIObj = null;
  prevVisible = false;
  scrollViewIntervalPrimary = null; scrollViewIntervalSecondary = null;
  hasSavedAsset = false;
  loadAssetCounter = 0;
  streetDataComp;
  hasOnFieldValueChange = false;
  streetDataInit;
  
  disableAddress = false;

  constructor(
    public httpService: HttpService,
    public cdRef: ChangeDetectorRef,
    private searchService: SearchService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    private sclUtilMapService: SclUtilMapService,
    private sclAssetLayersService: SclAssetLayersService,
    private sclMapViews: SclMapViewsService,
    private httpClient: HttpClient,
    private notificationService: NotificationService,
    private configService: ConfigService,
    protected formbirdInjectorService: FormbirdInjectorService,
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);

    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');

    this.fileProviderService = this.formbirdInjectorService.get('FileProviderService');

    this.unsavedDocumentService = this.formbirdInjectorService.get(
      'UnsavedDocumentService'
    );
    this.searchClientService = this.formbirdInjectorService.get('SearchClientService');

    this.mapFunc = new SclMappingFunctionsService(httpClient, cdRef, notificationService);
    this.mapFunc.loadInitialMapView = this.loadInitialMapView.bind(this);
    this.mapFunc.setPositionForAsset = this.setPositionForAsset.bind(this);
    this.mapFunc.setSelectedAssetVisualize = this.setSelectedAssetVisualize.bind(this);
    this.mapFunc.createFeature = this.createFeature.bind(this);
    this.mapFunc.updateAddress = this.updateAddress.bind(this);
    this.mapFunc.updateMap = this.updateMap.bind(this);
    this.mapFunc.currentLocationCheckBoxOnClick = this.currentLocationCheckBoxOnClick.bind(this);

  }

  onFieldValueChanged(fieldValue) {
    if (isEqual(this.fieldValue, fieldValue)) {
      this.detectFieldValueChange(fieldValue); // 16835#c72088
      return;
    }

    this.fieldValue = cloneDeep(fieldValue);
    if (!fieldValue) {
      this.removeStreet();
    }

    if (this.fieldValue && this.fieldValue.features && isArray(this.fieldValue.features)) {
      let hasPrimary = false; let hasSecondary = false; let hasAddress = false;
      for (let i = 0; i < this.fieldValue.features.length; i++) {
        if (this.fieldValue.features[i].properties.type === MapSelectAssetType.PRIMARY) {
          hasPrimary = true;
        } else if (this.fieldValue.features[i].properties.type === MapSelectAssetType.SECONDARY) {
          hasSecondary = true;
        } else if (this.fieldValue.features[i].properties.type === MapSelectAssetType.STREET) {
          hasAddress = true;
        }
      }
      if (hasPrimary && this.initialMapView.indexOf('primary') < 0) { this.initialMapView.push('primary'); }
      if (hasSecondary && this.initialMapView.indexOf('secondary') < 0) { this.initialMapView.push('secondary'); }
      if (hasAddress && this.initialMapView.indexOf('address') < 0) { this.initialMapView.push('address'); }
      if (!hasPrimary && !hasSecondary && !hasAddress && this.initialMapView.indexOf('map') < 0) {
        this.initialMapView.push('map');
      }
    }


    this.detectFieldValueChange(this.fieldValue);
    this.detectChanges();
  }
  onComponentDefChanged(componentDefinition) {

    super.onComponentDefChanged(componentDefinition);
    let hasUpdate = false;
    let compDefVisible = true;
    if (!(typeof componentDefinition.visible === 'undefined' || componentDefinition.visible === null)) {
      compDefVisible = componentDefinition.visible;
    }
    if (this.prevVisible !== compDefVisible) {
      hasUpdate = true;
      this.prevVisible = compDefVisible;
    }
    if (hasUpdate && compDefVisible) {
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        this.mapFunc.showMap(this.showMap.bind(this));
      }
    }

    const obj = this.sclUtilMapService.checkDisableAddressEntry(this.componentDefinition, this.geocodeSearchService);
    this.mapFunc.isDisableAddressEntry = obj.disableAddressEntry;

    this.mapFunc.setActivateButtonLookupAddress();

    this.mapFunc?.switchMapView(this.componentDefinition?.mapParameters?.showMapView, this.keyName);
    
    this.cdRef.detectChanges();
  }

  showMap() {
    clearInterval(this.scrollViewIntervalPrimary);
    this.scrollViewIntervalPrimary = null;
    clearInterval(this.scrollViewIntervalSecondary);
    this.scrollViewIntervalSecondary = null;
    this.setPrimaryScrollView();
    this.setSecondaryScrollView();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.mapFunc.unregisterMapWrapperChange(this.mapWrapper);
  }

  ngOnInit() {
    this.prevVisible = this.componentDefinition.visible;

    this.mapFunc.tooltipHandleBarObjects = [];
    this.componentSetupService.setupStandardProperties(this);
    this.fullWidthClass = ( this.componentDefinition.fullWidth
       ? 'sc-selected-asset-fullwidth' : 'sc-selected-asset-not-fullwidth' ); // removed class
    this.visible = this.componentDefinition.visible;
    this.showInPrint = '';
    sclHandlebars.initHandlebars(this.componentDefinition.handlebarsHelpers);
    this.keyName = this.fieldName + this.template.documentId;

    this.mapFunc.addressId = this.keyName + '_address';
    this.mapFunc.contextParams = {
      doc : this.document,
      account: this.loggedInUserService.user.account,
      tpl: this.template,
      tplItem: this.componentDefinition
    };

    // Debounce settings for address entry

    if (this.configService.clientConfig().searchDelay) {
      this.debounce = this.configService.clientConfig().searchDelay;
    }
    if (this.componentDefinition.searchDelay) {
      this.debounce = this.componentDefinition.searchDelay;
    }
    this.searchMinLength = SclMapConstantService.DEFAULT_SEARCH_LENGTH;
    if (this.componentDefinition.searchMinLength) {
      this.searchMinLength = this.componentDefinition.searchMinLength;
    }

    if (this.componentDefinition) {
      if (this.componentDefinition.maxVectorItems) {
        this.mapFunc.pageSize = this.componentDefinition.maxVectorItems;
      }
      if (this.componentDefinition.queryPageSize) {
        this.mapFunc.pageSize = this.componentDefinition.queryPageSize; // 14603 : override assetField.maxVectorItems
      }
      if (this.componentDefinition.singlePrimaryAssetSelection) {
        this.singlePrimaryAssetSelection = this.componentDefinition.singlePrimaryAssetSelection; }
      if (this.componentDefinition.singleSecondaryAssetSelection) {
        this.singleSecondaryAssetSelection = this.componentDefinition.singleSecondaryAssetSelection; }
      if (!this.componentDefinition.noSecondaryAssetSelection) {
        this.noSecondaryAssetSelection = this.componentDefinition.noSecondaryAssetSelection; }
      if (this.componentDefinition.geoJsonField) { this.geoJsonField = this.componentDefinition.geoJsonField; }
      if (this.componentDefinition.maxItems) { this.maxItems = this.componentDefinition.maxItems; }
      if (this.componentDefinition.delayBeforeCallNum) {this.timeDelay = this.componentDefinition.delayBeforeCallNum; }
      if (this.componentDefinition.disableMouseWheel) {this.disableMouseWheel = this.componentDefinition.disableMouseWheel; }

      if (this.componentDefinition.mapSource) {this.mapSource = this.componentDefinition.mapSource; }

      if (this.componentDefinition.mapParameters) {
        this.mapParameters = this.componentDefinition.mapParameters;
        if (this.mapParameters.EPSG) { this.mapFunc.EPSG = this.mapParameters.EPSG; }
        if (this.mapParameters.searchZoom) { this.searchZoom = this.mapParameters.searchZoom; }
      }
      if (this.componentDefinition.primaryImageFileNo) {
        this.primaryIcon = this.componentDefinition.primaryImageFileNo; }
      if (this.componentDefinition.secondaryImageFileNo) {
        this.secondaryIcon = this.componentDefinition.secondaryImageFileNo; }
      if (this.componentDefinition.secondaryImageAnchor) { this.secondaryImageAnchor = this.componentDefinition.secondaryImageAnchor; }
      if (this.componentDefinition.primaryImageAnchor) { this.primaryImageAnchor = this.componentDefinition.primaryImageAnchor; }
      if (this.componentDefinition.addressImageAnchor) { this.addressImageAnchor = this.componentDefinition.addressImageAnchor; }
      if (this.componentDefinition.primaryAssetAddressField) {
        this.mapFunc.primaryAssetAddressField = this.componentDefinition.primaryAssetAddressField; }
      if (this.componentDefinition.primaryAssetGeometryField) {
        this.mapFunc.primaryAssetGeometryField = this.componentDefinition.primaryAssetGeometryField; }
      if (this.componentDefinition.secondaryAssetAddressField) {
        this.mapFunc.secondaryAssetAddressField = this.componentDefinition.secondaryAssetAddressField; }
      if (this.componentDefinition.secondaryAssetGeometryField) {
        this.mapFunc.secondaryAssetGeometryField = this.componentDefinition.secondaryAssetGeometryField; }
      if (this.componentDefinition.addressImageFileNo) {
        this.addressMarker = this.componentDefinition.addressImageFileNo; }
      if (this.componentDefinition.positionMandatory) { this.positionMandatory = this.componentDefinition.positionMandatory; }
      if (!(typeof this.componentDefinition.tooltipsTimeout === 'undefined' ||
      this.componentDefinition.tooltipsTimeout === null)) {
        this.mapFunc.tooltipsTimeout = this.componentDefinition.tooltipsTimeout;
      }
      if (this.componentDefinition.hideAddress) { this.hideAddress = this.componentDefinition.hideAddress; }
      if (this.componentDefinition.popupAssetSelection) { this.popupAssetSelection = this.componentDefinition.popupAssetSelection; }
      if (this.componentDefinition.popupAssetSelectionPrimaryText) {
        this.mapFunc.popupAssetSelectionPrimaryText = this.componentDefinition.popupAssetSelectionPrimaryText; }
      if (this.componentDefinition.popupAssetSelectionSecondaryText) {
        this.mapFunc.popupAssetSelectionSecondaryText = this.componentDefinition.popupAssetSelectionSecondaryText; }
      if (this.componentDefinition.geocodeSearchService) {
        this.geocodeSearchService = this.componentDefinition.geocodeSearchService;
        if (Array.isArray(this.geocodeSearchService) && this.geocodeSearchService.length > 0 ) {
          for (let i = 0; i < this.geocodeSearchService.length; i++) {
            if (this.geocodeSearchService[i].name === 'doc') {
              if (this.geocodeSearchService[i].relatedDocument) {
                this.geoRelatedDocuments = this.geocodeSearchService[i].relatedDocument;
              }
              break;
            }
          }
        }
      }
      if (this.componentDefinition.disableAddress) {
        this.disableAddress = this.componentDefinition.disableAddress;
      }
      
      if ( !(typeof this.componentDefinition.initialAssetLoading === 'undefined' ||
      this.componentDefinition.initialAssetLoading === null) ) {
        this.initialAssetLoading = this.componentDefinition.initialAssetLoading;
      }
      this.initialAssetLoadArc = this.initialAssetLoading;
      if (this.componentDefinition.selection) { this.selection = this.componentDefinition.selection; }
      if (this.componentDefinition.centerOnReverse) { this.centerOnReverse = this.componentDefinition.centerOnReverse; }
      if (this.componentDefinition.asyncDrawAsset) { this.mapFunc.asyncDrawAsset = this.componentDefinition.asyncDrawAsset; }// 14752 : for test
      if (this.componentDefinition.initialMapView) { this.initialMapView = this.componentDefinition.initialMapView; }// 14781
      if (this.componentDefinition.moveToSelectedSearchAsset) {
        this.moveToSelectedSearchAsset = this.componentDefinition.moveToSelectedSearchAsset;
      }// 15262
      if (!(typeof this.componentDefinition.disableHandlebars === 'undefined' ||
      this.componentDefinition.disableHandlebars === null)) {
        this.mapFunc.disableHandlebars = this.componentDefinition.disableHandlebars;
      }// 15250
      if (this.componentDefinition.showTiming) {
        this.mapFunc.showTiming = this.componentDefinition.showTiming;
      }// 15250
      if(this.componentDefinition.primaryAssetAddressLookupPoint) {
        this.primaryAssetAddressLookupPoint = this.componentDefinition.primaryAssetAddressLookupPoint; // 15393
      }
      if(this.componentDefinition.primaryAssetAddressLookup) {
        this.primaryAssetAddressLookup = this.componentDefinition.primaryAssetAddressLookup; // 15393
      }
      if(this.primaryAssetAddressLookup) {
          var isValidRadius = false, isValidTimeout = false;
          if(!(typeof this.componentDefinition.primaryAssetAddressLookupRadius === 'undefined'
           || this.componentDefinition.primaryAssetAddressLookupRadius === null)) {
              if ( Number.isInteger(this.componentDefinition.primaryAssetAddressLookupRadius)
               && this.componentDefinition.primaryAssetAddressLookupRadius > 0) {
                  this.primaryAssetAddressLookupRadius = this.componentDefinition.primaryAssetAddressLookupRadius;
                  isValidRadius = true;
              } else {
                  console.error('primaryAssetAddressLookupRadius is not a number or the value must be greater than zero');
              }
          }
          if(!(typeof this.componentDefinition.primaryAssetAddressLookupTimeout === 'undefined'
           || this.componentDefinition.primaryAssetAddressLookupTimeout === null)) {
              if ( Number.isInteger(this.componentDefinition.primaryAssetAddressLookupTimeout)
               && this.componentDefinition.primaryAssetAddressLookupTimeout > 0) {
                this.primaryAssetAddressLookupTimeout = this.componentDefinition.primaryAssetAddressLookupTimeout;
                isValidTimeout = true;
              } else {
                  console.error('primaryAssetAddressLookupTimeout is not a number or the value must be greater than zero');
              }
          }
          if (Array.isArray(this.geocodeSearchService) && this.geocodeSearchService.length > 0 ) {
              for (var i = 0; i < this.geocodeSearchService.length; i++) {
                  if (this.geocodeSearchService[i].name === 'psma') {
                      if (isValidRadius) {
                        this.geocodeSearchService[i].enableReverseRadiusDisplay = true;
                        this.geocodeSearchService[i].primaryAssetAddressLookupRadius = this.primaryAssetAddressLookupRadius;
                        this.geocodeSearchService[i].enableReverseRadiusDisplay = false;
                      }
                      if (isValidTimeout) {
                        this.geocodeSearchService[i].timeWait = this.primaryAssetAddressLookupTimeout * 1000; // convert from second to milisecond
                      }
                      this.geocodeSearchService[i].hasPrimaryAssetAddressLookup = true;
                  } else if (this.geocodeSearchService[i].name === 'here') {
                      if (isValidRadius) {
                        this.geocodeSearchService[i].primaryAssetAddressLookupRadius = this.primaryAssetAddressLookupRadius;
                      }
                  }
              }
          } else if(typeof this.geocodeSearchService === 'object' && this.geocodeSearchService !== null) {
              for (var key in this.geocodeSearchService) {
                  if (isValidTimeout) {
                    this.geocodeSearchService[key].timeWait = this.primaryAssetAddressLookupTimeout;
                  }
                  if (isValidRadius) {
                      if (key === 'psma') {
                        this.geocodeSearchService[key].enableReverseRadiusDisplay = true;
                        this.geocodeSearchService[key].primaryAssetAddressLookupRadius = this.primaryAssetAddressLookupRadius;
                        this.geocodeSearchService[i].enableReverseRadiusDisplay = false;
                      } else if(key === 'here') {
                        this.geocodeSearchService[key].primaryAssetAddressLookupRadius = this.primaryAssetAddressLookupRadius;
                      }
                  }
                  if (key === 'psma' || key === 'here') {
                    this.geocodeSearchService[key].hasPrimaryAssetAddressLookup = true;
                  }
              }
          }
      }

      if ( typeof this.componentDefinition.mandatoryValuesArray === 'undefined' ||
        this.componentDefinition.mandatoryValuesArray === null  ||
        this.componentDefinition.mandatoryValuesArray.length === 0 ) {
        this.componentDefinition.mandatoryValuesArray = [
              {
                  name: 'Please select a Primary Asset using the P option',
                  jsonPathQuery: '$..features[?(@.properties.type == "primaryAsset")]'
              },
              {
                  name: 'Please enter or select a valid address that contains a Street Name',
                  jsonPathQuery: '$..features[?(@.properties.street)]'
              },
              {
                  name: 'Please enter or select a valid address that contains a Suburb',
                  jsonPathQuery: '$..features[?(@.properties.suburb)]'
              }
          ];
      }
      if (this.componentDefinition.layers) {
        let idx = 0;
        for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
          idx++;
          // 2. another logic for layerAssets independence with logic 1.
          let isHeatMap = false;
          if (this.componentDefinition.layers[i].type && this.componentDefinition.layers[i].type === 'heatmap') {
            isHeatMap = true;
          }
          this.mapFunc.layerAssets.push({query: this.componentDefinition.layers[i].filter + '_layer_' + idx, i: idx
            , isHeatMap, layer: this.componentDefinition.layers[i], isFilter: false
            , currentFilter: this.componentDefinition.layers[i].filter, features: []});

          // 3. 14104
          if (this.componentDefinition.layers[i].assetSelectionsAvailable) {
            let iAvailable = [];
            for (let j = 0; j < this.componentDefinition.layers[i].assetSelectionsAvailable.length; j++) {
              const item = this.componentDefinition.layers[i].assetSelectionsAvailable[j].toLowerCase();
              if (item === 'all') {
                if (typeof this.componentDefinition.layers[i].layerDisplayOnly === 'undefined' ||
                  this.componentDefinition.layers[i].layerDisplayOnly === null
                    || this.componentDefinition.layers[i].layerDisplayOnly === false) {
                  iAvailable = ['primary', 'secondary'];
                } else { iAvailable.push('all'); }
                break;
              } else { iAvailable.push(item); }
            }
            this.assetSelectionsAvailable.push(iAvailable);
          } else {
            if (typeof this.componentDefinition.layers[i].layerDisplayOnly === 'undefined' ||
              this.componentDefinition.layers[i].layerDisplayOnly === null
                || this.componentDefinition.layers[i].layerDisplayOnly === false) {
              this.assetSelectionsAvailable.push(['primary', 'secondary']); // assetSelectionsAvailable = NULL
            } else {
              this.assetSelectionsAvailable.push(['all']);
            }
          }
        }
      }
      if (this.componentDefinition.filter) {
        const layerIndex = (this.componentDefinition.layers ? this.componentDefinition.layers.length + 1 : 1);
        const layerFilter = this.sclUtilMapService.buildFilterObj(this.componentDefinition, this.geoJsonField);
        this.mapFunc.layerAssets.push({query: this.componentDefinition.filter + '_filter_' + layerIndex, i: layerIndex
          , isHeatMap: false, layer: layerFilter, isFilter: true
          , currentFilter: this.componentDefinition.filter, features: [] });
      }


      // zoomFloor
      if (this.componentDefinition.zoomFloor) { this.zoomFloor = this.componentDefinition.zoomFloor; }

      // 14502
      if (this.componentDefinition.lookupAddressForPrimaryAsset) {
        this.lookupAddressForPrimaryAsset = this.componentDefinition.lookupAddressForPrimaryAsset; }// 14502
      if (this.componentDefinition.lookupAddressForSecondaryAsset) {
        this.lookupAddressForSecondaryAsset = this.componentDefinition.lookupAddressForSecondaryAsset; }// 14502

      if (this.componentDefinition.searchAssetSelectionInclude) {
        this.searchAssetSelectionInclude = this.componentDefinition.searchAssetSelectionInclude;
      }

      // test re-draw layer
      if (this.componentDefinition.layersRedraw) { this.layersRedraw = this.componentDefinition.layersRedraw; }
    }
    this.setupChangeDetection();

    const panelSub = this.broadcastService.on('panel-comp-def-updated').subscribe((data) => {
      if (data?.startKey < this.key && this.key < data?.endKey) {
        if (this.componentDefinition.visible !== false) {
          if (this.mapLibName === MapLibraryName.OPEN_LAYER && this.mapFunc) {
            this.mapFunc.showMap();
          }
        }
      }
    });
    this.subs.add(panelSub);

    const docSub = this.changedDocumentService.watchDocument(this.document.documentId).subscribe(doc => {
      
      this.document = doc;
      this.mapFunc.contextParams.doc = doc;

    });
    this.subs.add(docSub);


    // flexible height of map
    this.mapFunc.mapHeight = this.calculateMapHeight();

    // create id component as following format <fieldName>_<componentName>_<nameOfElementUnderComponent>
    this.addressLookupId   = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'addressLookup';
    this.unitNoId          = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'unitNo';
    this.streetNoId        = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'streetNo';
    this.streetNameId      = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'streetName';
    this.suburbTownId      = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'suburbTown';
    this.stateId           = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'stateNo';
    this.countryId         = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'country';
    this.postCodeId        = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'postCode';
    this.addrDescriptionId = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'addrDescription';
    this.latitudeId        = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'latitude';
    this.longtitudeId      = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + 'longtitude';
    this.primaryAssetId    = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + MapSelectAssetType.PRIMARY;
    this.secondaryAssetId  = this.componentDefinition.name + '_' + this.componentDefinition.componentName + '_' + MapSelectAssetType.SECONDARY;

    this.bodyRect = document.body.getBoundingClientRect(); // 14327

  }



  setupChangeDetection() {
    super.setupChangeDetection();
  }


  removeDuplicates(originalArray, isGeometry) {
    const temp = [];
    for (let i = 0; i < originalArray.length; i++) {
      const current = originalArray[i];
      
      const type = current.properties.type;
      
      if (type === MapSelectAssetType.STREET) {
        temp.push(current);
        continue;
      }
      
      const id = current.properties.linkAssets[0].documentId;

      const currentGeoms = current.geometries ?? [current.geometry];

      let hasItem = false;

      for (let j = 0; j < temp.length; j++) {
        const candidate = temp[j];
        if (candidate.properties && candidate.properties.linkAssets
           && candidate.properties.linkAssets[0].documentId === id
           && candidate.properties.type === type) {
          if (isGeometry) {
            const candidateGeoms = candidate.geometries ?? [candidate.geometry];

            if (currentGeoms.some(g1 =>
              candidateGeoms.some(g2 => isEqual(g1, g2))
            )) {
              hasItem = true;
              break;
            }
          } else {
            hasItem = true;
            break;
          }
        }
      }
      if (hasItem === false) {
        temp.push(current);
      }
    }
    const json = cloneDeep(temp);
    return json;
  }


  setDocDirtyAsset(scopeAsset, assets) {
    const temp = cloneDeep(this.mapFunc.featureCollections.features);

    scopeAsset = this.removeDuplicates(scopeAsset, null);
    
    for (let i = 0; i < scopeAsset.length; i++) {
      const pri = scopeAsset[i];
      if (pri.street) {
        delete pri.street;
      }
      if (typeof(pri.$$hashKey) !== 'undefined' ) {
        delete pri.$$hashKey;
      }

      // remove relatedField in linkAsset
      if (pri.properties && pri.properties.linkAssets 
        && Array.isArray(pri.properties.linkAsset)
        && pri.properties.linkAssets.length > 0) {
        pri.properties.linkAssets[0] = this.checkLinkAssets(pri.properties.linkAssets[0]);
      }

      if (assets != null) {
        if (assets.length > 0) {
          const id = pri.properties.linkAssets[0].documentId;
          for (let j = 0; j < assets.length; j++) {
            if (assets[j].id.indexOf(id) > -1) {
              assets[j].asset.properties.linkAssets[0].documentId = id;
              assets[j].asset.properties.linkAssets[0] = this.checkLinkAssets(assets[j].asset.properties.linkAssets[0]);
              if (Array.isArray(assets[j].asset.geometries)) {
                assets[j].asset.type = FEATURE_TYPE.GEOMETRY_COLLECTION;
              }
              temp.push(assets[j].asset);
            }
          }
        } else {
          temp.push(pri);
        }
      } else {
        temp.push(pri);
      }
      
    }

    this.mapFunc.featureCollections.features = cloneDeep(temp);
  }
  checkLinkAssets(obj) {
    for (const field in this.mapFunc.relatedAsset) {
      if (this.mapFunc.relatedAsset.hasOwnProperty(field)) {
        const oValue = obj[field]; const rValue = this.mapFunc.relatedAsset[field];
        if (oValue === rValue) {
          delete obj[field];
        }
      }
    }
    if (obj.documentId) {
      obj.documentId = obj.documentId.replace('_dash', '').replace('_primary', '').replace('_secondary', '');
      if (obj.documentId.indexOf('_') > -1) {
        obj.documentId = obj.documentId.split('_')[0];
      }
    }
    return obj;
  }

  updateAssetPosition(lat, long, oldId, name, type) {
    if (!isFinite(lat) || !isFinite(long)) { return; }
    const id = oldId + '_' + type;
    const image = (type === MapSelectAssetType.SECONDARY ? this.secondaryIcon : this.primaryIcon) ;
    if (this.mapFunc.showTiming) {
      console.log(`start time create ${type} asset: ${(new Date()).toISOString()}
      , id = ${id}`);
    }
    this.mapFunc.mapObj.createMarkerAsset(lat, long, id, image, name, type);
    if (this.mapFunc.showTiming) {
      console.log(`end time create ${type} asset: ${(new Date()).toISOString()}
      , id = ${id}`);
    }

  }

  getFeaturesFromMap(features, pixel, type) {
    return this.mapFunc.mapObj.getFeaturesFromMap(features, pixel, type, this.assetSelectionsAvailable);
  }



  detectFieldValueChange(pNewValue) {
    if (!pNewValue || !this.mapFunc || !this.mapFunc.mapObj) {
      return;
    }
    let newValue = cloneDeep(pNewValue);

    this.documentOldValue = this.sclUtilMapService.checkScopeValue(this.documentOldValue, MapSelectAssetType.STREET);
    newValue = this.sclUtilMapService.checkScopeValue(newValue, MapSelectAssetType.STREET);

    if (!isEqual(this.documentOldValue, newValue)) {
      this.documentOldValue = cloneDeep(pNewValue);
      this.detectDocChange(newValue);
      this.loadAsset('has field value change', false); // 16005
    }
  }
  detectDocChange(newValue) {
    this.isDocFieldValueChanged = true;
    const ast = {
      primary: [],
      secondary: []
    };
    let streetData;
    const primaryAsset = this.mapFunc.mapObj.getAllFeatures();
    for (let i = 0; i < primaryAsset.length; i++) {
      const pri = primaryAsset[i];
      const priId = this.mapFunc.mapObj.getFeatureId(pri);
      const type = this.mapFunc.mapObj.getFeatureProperty(pri, 'assetType');

      if ((type === MapSelectAssetType.PRIMARY
         && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT)
        || (type === MapSelectAssetType.SECONDARY
           && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT)) {
        const f = this.mapFunc.mapObj.getFeatureById(priId);
        if (f) {
          this.mapFunc.mapObj.removeFeature(f);
        }
      }
    }

    if (!newValue) {
      this.removeStreet();
      ast.primary = [];
      ast.secondary = [];
      this.assetsPrimary = '[]';
      this.assetsSecondary = '[]';
      return;
    }

    const length = newValue?.features?.length;

    for (let i = 0; i < length; i++) {
      const asset = cloneDeep(newValue.features[i]);
      if (asset.properties.type === MapSelectAssetType.PRIMARY) {
        ast.primary.push(asset);
      } else if (asset.properties.type === MapSelectAssetType.SECONDARY) {
        ast.secondary.push(asset);
      } else if (asset.properties.type === MapSelectAssetType.STREET) {
        if (typeof (asset.geometry) === 'undefined' || asset.geometry === null || asset.geometry.coordinates.length === 0) {
          // continue; // 15690: it won't update streetData from onFieldValueChanged flow after removing street
          this.removeStreet(); // 15690: need to remove street marker because this street is invalid data
        }
        streetData = asset;
        this.sclUtilMapService.checkStreetGeometryComponent(this.streetDataComp, this.keyName);
        this.resetPostionMandatory();
      }
    }

    if (this.primaryAssetSelectionMode === MapSelectAssetMode.ASSET) {
      ast.primary = this.removeDuplicates(ast.primary, false);
    }
    if (this.secondaryAssetSelectionMode === MapSelectAssetMode.ASSET) {
      ast.secondary = this.removeDuplicates(ast.secondary, false);
    }

    let pAssetsPrimary = JSON.stringify(ast.primary); let pAssetsSecondary = JSON.stringify(ast.secondary);

    let previouseStreetData = (this.streetDataComp ? this.streetDataComp.streetData[this.keyName] : null);

    if (streetData && !isEqual(previouseStreetData, streetData)) {
      if (!this.streetDataComp) {
        this.hasOnFieldValueChange = true;
        this.streetDataInit = streetData;
      } else {
        this.streetDataComp.streetDataStr = JSON.stringify(streetData);
      }

      if (!(typeof (streetData.geometry) === 'undefined' || streetData.geometry === null
        || streetData.geometry.coordinates.length === 0)) {
        const coords = streetData.geometry.coordinates;
        if (!this.clickPoint) {
          this.updateMap(coords[1], coords[0], false, true);
        }
      } // 15690: it won't update streetData from onFieldValueChanged flow after removing street ( fixed )

    } else {
      this.isDocFieldValueChanged = false;
    }

    // if (this.mapLibName !== MapLibraryName.GOOGLE) {
      if (this.primaryAssetSelectionMode === MapSelectAssetMode.POINT) {
        const astPrimary = this.watchAsset(ast.primary, MapSelectAssetType.PRIMARY);
        pAssetsPrimary = JSON.stringify(astPrimary);
      }
      if (this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT) {
        const astSecondary = this.watchAsset(ast.secondary, MapSelectAssetType.SECONDARY);
        pAssetsSecondary = JSON.stringify(astSecondary);
      }
    // }
    this.assetsPrimary = pAssetsPrimary;
    this.assetsSecondary = pAssetsSecondary;
  }
  watchAsset(assets, sType) {
    for (let i = 0; i < assets.length; i++) {
      const pri = assets[i];
      if (typeof(assets[i].$$hashKey) !== 'undefined' ) {
        delete assets[i].$$hashKey;
      }
      
      if (pri.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
        if (Array.isArray(pri.geometries) === false) {
          console.log(`Selected Asset: this primary asset has no geometries data`);
          continue;
        }

        for (let j = 0; j < pri.geometries.length; j++) {
          const geometry = pri.geometries[j];
          if (geometry == null || geometry.coordinates == null) {
            console.log(`Selected Asset: this primary asset has no geometry data`);
            continue;
          }

          const documentId = `${pri.properties.linkAssets[0].documentId}_${j}`;

          this.centerOfAsset(sType, geometry, pri.properties.linkAssets[0].name, documentId
          );
        }
      } else {
        if (pri.geometry == null || pri.geometry.coordinates == null) {
          console.log(`Selected Asset: this primary asset has no geometry data`);
          continue;
        }

        const coor = this.centerOfAsset(sType, pri.geometry
          , pri.properties.linkAssets[0].name, pri.properties.linkAssets[0].documentId);
        if (coor !== null) {
          assets[i].geometry.coordinates = coor;
          assets[i].geometry.type = MapDrawType.POINT;
        }
        
      }
    }
    return assets;
  }

  centerOfAsset(sType, geometry, name, documentId) {
    let coor = null;
    if ( (sType === MapSelectAssetType.PRIMARY
       && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT) ||
      (sType === MapSelectAssetType.SECONDARY
         && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT) ) {
      const docId = documentId;
      coor = this.sclUtilMapService.getCenterOfGeometry(geometry.coordinates, geometry.type); // pri.geometry.coordinates;
      
      this.updateAssetPosition(coor[1], coor[0], docId, name, sType);
    }
    return coor;
  }

  

  getHTMLTooltip(features, currentAssets, header) {
    if (features === undefined || features.length === 0) {
        return;
    }

    this.postList = [];
    for (let i = 0; i < features.length; i++) {
      const feature = features[i];
      const properties = this.mapFunc.mapObj.getFeatureProperties(feature, ['name', 'id', 'primaryMultiPopup', 'secondaryMultiPopup']);
      const name = properties.name;
      const docId = properties.id;
      if (docId.indexOf('address') > -1 || name.indexOf('address') > -1) { continue; }
      let id0 = docId;

      const exist = this.mapFunc.isContainFeature(docId, currentAssets);
      let check = '';
      if (exist) {
        check = 'checked';
      }
      const id = this.keyName + i + 'popup';
      const cbName = this.keyName + 'popup';
      let html = '';
      let tooltip = name;
      if (this.isPrimaryAsset) {
          if (properties.primaryMultiPopup) { tooltip = properties.primaryMultiPopup; }
          if (this.singlePrimaryAssetSelection) {
            html += '<input class="popupAsset" type=\'radio\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
          } else {
            html += '<input class="popupAsset" type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>'; }
      } else if (this.isSecondaryAsset) {
          if (properties.secondaryMultiPopup) { tooltip = properties.secondaryMultiPopup; }
          if (this.singleSecondaryAssetSelection) {
            html += '<input type=\'radio\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>'; }
          html += '<input type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
      }

      html += tooltip;
      this.postList.push(html);
    }

    this.disablePopupOkButton = !(this.isSecondaryAsset || this.isPrimaryAsset);

    this.showPopupRadio();
    this.cdRef.detectChanges();
  }


  onGetStreetData(streetData: any) {
    if (streetData) {
      this.getRelatedDocument(streetData);
    }

    this.clickPoint = null; // 14502
    this.mapFunc.hasMapDragging = true;
    this.mapFunc.subLabelTiming = 'Get-Street-Data-By-Typing-Address';

    this.primaryAssetAddressLookupClickPoint = null; // 15393
    this.streetDataComp.streetDataStr = JSON.stringify(streetData);
    this.updateChange();

    this.streetDataComp.streetData[this.keyName] = new AddressDetails();
    if (this.mapGeo != null) {
      this.mapGeo.removeFeatures();
    }
    if (streetData == null) {
      return;
    }
    this.streetDataComp.streetData[this.keyName] = cloneDeep(streetData);
    this.hasAddressPin = true;
    this.cdRef.detectChanges();
    this.updateMap(streetData.geometry.coordinates[1], streetData.geometry.coordinates[0],
        false, true);
    this.resetPostionMandatory();
  }

  onRemoveStreetCb() {
    this.removeRelatedDocument();

    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
    const fea = this.mapFunc.mapObj.getFeatureById(this.mapFunc.addressId);
    if (fea) {
      this.removeStreet();
    }
    else {
      this.resetAddressData();
    }
    this.streetDataComp.streetDataStr = null;
    this.updateChange();
  }

  onLookUpResultCb() {
    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
  }

  onLookUpErrorCb() {
    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
  }

  addMapViewControl(element, options, controlElement) {
    this.mapFunc.addMapViewControl(element, this.keyName, this.layerIds);

    this.mapFunc.mapObj.layersRedraw = this.layersRedraw;
    this.mapFunc.mapObj.layersRedrawCount = ( (this.componentDefinition.layers) ?
      this.componentDefinition.layers.length : 0 ) + ( (this.componentDefinition.filter) ? 1 : 0 );
    this.mapFunc.mapObj.addControl(this, element, options);
    this.mapFunc.mapObj.elementCtrl = controlElement;
  }

  showPopupRadio() {
    this.mapFunc.divInfo1.nativeElement.click();

    this.mapFunc.isPopupRadioOpen = true;
    const popover = this.mapFunc.divInfo1.nativeElement.querySelectorAll('div.popover')[0];
    if (popover) {
        const lst = document.querySelectorAll('[content-exp="contentExp()"]');
        if (lst != null && lst.length > 0) {
          const item: any = lst[0];
          item.style.zIndex = this.mapFunc.mapObj.layerIndexTooltips;
        }
    }
  }
  removeStreet() {
    const fea = this.mapFunc.mapObj.getFeatureById(this.mapFunc.addressId);

    this.mapFunc.mapObj.removeLocation(fea);
    this.resetAddressData();

  }
  drawStart(evt) {
    if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      const feature = evt.feature;
      feature.setId('1');
    }
  }
  drawEnd(evt) {
    // console.log(`**** click on map to select primary/secondary asset`);
    this.removeDraw();
    if (this.disabled) { return; }
    this.clickPoint = null;
    this.primaryAssetAddressLookupClickPoint = null; // 15393
    if (this.isPrimaryAsset) {
      if (this.mapLibName !== MapLibraryName.GOOGLE) {
        this.removeDraw();
        this.primaryAssetAddressLookupClickPoint = evt.latLng; // 15393
      } else {
        this.primaryAssetAddressLookupClickPoint = { lat: evt.latLng[1], lng: evt.latLng[0] }; // 15393
      }
      if (this.lookupAddressForPrimaryAsset) {
        this.clickPoint = evt.latLng;
      }
      this.switchPrimaryAssetAddressLookUp(true);
      this.primaryAssetAction(evt);
    }
    if (this.isSecondaryAsset) {
      if (this.mapLibName !== MapLibraryName.GOOGLE) { this.removeDraw(); }
      if (this.lookupAddressForSecondaryAsset) {
        this.clickPoint = evt.latLng;
      }
      this.secondaryAssetAction(evt);
    }
  }
  switchPrimaryAssetAddressLookUp(isOn) {
    if ( this.primaryAssetAddressLookup ) {
        if (Array.isArray(this.geocodeSearchService) && this.geocodeSearchService.length > 0 ) {
            for (var i = 0; i < this.geocodeSearchService.length; i++) {
                if (this.geocodeSearchService[i].name === 'psma' || this.geocodeSearchService[i].name === 'here') {
                  this.geocodeSearchService[i].hasPrimaryAssetAddressLookup = isOn;
                }
            }
        } else if(typeof this.geocodeSearchService === 'object' && this.geocodeSearchService !== null) {
            for (var key in this.geocodeSearchService) {
                if (key === 'psma' || key === 'here') {
                  this.geocodeSearchService[key].hasPrimaryAssetAddressLookup = isOn;
                }
            }
        }
    }
  }
  setActive(active) {
    this.mapFunc.mapObj.removeInteractionDraw();
    this.mapFunc.mapObj.removeInteractionSnap();
    if (active) {
      this.mapFunc.mapObj.addInteractionDraw(this.drawStart.bind(this), this.drawEnd.bind(this));
      this.mapFunc.mapObj.addInteractionSnap();
    }
  }

  updateAsset(assets, type) {
    for (let i = 0; i < assets.length; i++) {
      const linkAsset = assets[i];
      if (linkAsset.properties && Array.isArray(linkAsset.properties.linkAssets)
        && linkAsset.properties.linkAssets.length > 0) {
        const id = linkAsset.properties.linkAssets[0].documentId;
        const name = linkAsset.properties.linkAssets[0].name;
        if (typeof id !== 'string') {
          console.log(`the asset has invalid data: `, linkAsset);
          continue;
        }

        if (linkAsset.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
          if (Array.isArray(linkAsset.geometries) === false) {
            console.log(`Selected Asset: this primary asset ${id} has no geometries data`);
            continue;
          }

          for (let j = 0; j < linkAsset.geometries.length; j++) {
            const geometry = linkAsset.geometries[j];
            if (geometry == null || geometry.coordinates == null) {
              console.log(`Selected Asset: this primary asset ${id} has no geometry data`);
              continue;
            }

            const coor = this.sclUtilMapService.getCenterOfGeometry(geometry.coordinates, geometry.type);
            this.updateAssetPosition(coor[1], coor[0], `${id}_${j}`, name, type);

          }
        } else {
          if (linkAsset.geometry == null || linkAsset.geometry.coordinates == null) {
            console.log(`Selected Asset: this primary asset ${id} has no geometry data`);
            continue;
          }

          const coor = this.sclUtilMapService.getCenterOfGeometry(linkAsset.geometry.coordinates, linkAsset.geometry.type);
          assets[i].geometry.type = MapDrawType.POINT;
          assets[i].geometry.coordinates = coor;
          this.updateAssetPosition(coor[1], coor[0], id, name, type);
        }
        
      } else {
        console.log(`the asset has invalid data: `, linkAsset);
      }
    }
  }
  updateMap(lat, long, isMapClick, isZoomToLocation) {
    this.mapFunc.mapObj.updateLocation(lat, long, this.mapFunc.addressId, this.addressMarker, 'address'
    , this.mapFunc.addressId, isMapClick);
    if (isZoomToLocation) {this.mapFunc.mapObj.zoomToLocation(lat, long); }
    if (this.mapLibName === MapLibraryName.GOOGLE) {
      this.mapFunc.mapObj.zoomToValue(18); // 14406
    }
    if (this.hasAddressPin) {
      this.mapFunc.mapObj.zoomToValue(this.searchZoom); // 14479#0053120 ( just use for comp-dev )
      this.hasAddressPin = false;
    }
  }
  // draw selected asset on map when save document
  setPositionForAsset() {
    // console.log(`%c **** setPositionForAsset`, 'color:red');

    this.primaryAssetAddressLookupClickPoint = null;
    if (this.mapFunc.featureCollections && this.mapFunc.featureCollections.features) {
      let hasUpdateAddress = false;
      if (this.streetDataComp && this.streetDataComp.streetData && this.streetDataComp.streetData[this.keyName]
        && this.streetDataComp.streetData[this.keyName].geometry) {
        if (this.streetDataComp.streetData[this.keyName].geometry.coordinates
            && this.streetDataComp.streetData[this.keyName].geometry.coordinates[0]
            && this.streetDataComp.streetData[this.keyName].geometry.coordinates[1]) {
            this.updateMap(this.streetDataComp.streetData[this.keyName].geometry.coordinates[1],
                this.streetDataComp.streetData[this.keyName].geometry.coordinates[0], false, true);
            hasUpdateAddress = true;
        }
        this.streetDataComp.bindStreetData(this.hideAddress);
      }

      const primaries = []; const secondaries = [];
      for (let i = 0; i < this.mapFunc.featureCollections.features.length; i++) {
          if (this.mapFunc.featureCollections.features[i].properties.type === MapSelectAssetType.PRIMARY) {
              primaries.push(this.mapFunc.featureCollections.features[i]);
          } else if (this.mapFunc.featureCollections.features[i].properties.type === MapSelectAssetType.SECONDARY) {
              secondaries.push(this.mapFunc.featureCollections.features[i]);
          } else if (hasUpdateAddress == false
             && this.mapFunc.featureCollections.features[i].properties.type === MapSelectAssetType.STREET
             && this.mapFunc.featureCollections.features[i].geometry
              && this.mapFunc.featureCollections.features[i].geometry.coordinates
               && Array.isArray(this.mapFunc.featureCollections.features[i].geometry.coordinates)
                && this.mapFunc.featureCollections.features[i].geometry.coordinates.length == 2
                 && this.mapFunc.featureCollections.features[i].geometry.coordinates[0]
                  && this.mapFunc.featureCollections.features[i].geometry.coordinates[1]) {
            this.updateMap(this.mapFunc.featureCollections.features[i].geometry.coordinates[1],
              this.mapFunc.featureCollections.features[i].geometry.coordinates[0], false, true);
          }
      }
      if (this.assets.primary && this.assets.primary.length > 0) {
          if (this.primaryAssetSelectionMode === MapSelectAssetMode.POINT) {
            this.updateAsset(this.assets.primary, MapSelectAssetType.PRIMARY);
          } else {
            this.addSelectedAsset(primaries, this.primaryIcon, MapSelectAssetType.PRIMARY);
          }
      }

      if (this.assets.secondary && this.assets.secondary.length > 0) {
          if (this.secondaryAssetSelectionMode === MapDrawType.POINT) {
            this.updateAsset(this.assets.secondary, MapSelectAssetType.SECONDARY);
          } else {
            this.addSelectedAsset(secondaries, this.secondaryIcon, MapSelectAssetType.SECONDARY);
          }
      }
      this.mapFunc.fitCoords(this.mapFunc.featureCollections.features);
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        this.mapFunc.mapObj.afterLoadSelectedAssetFn = this.afterLoadSelectedAssetFn.bind(this);
      } else if (this.mapLibName === MapLibraryName.GOOGLE && !this.initialAssetLoading) {
        this.hasSavedAsset = true;
      }
    }
  }
  // 15145
  afterLoadSelectedAssetFn() {
    const boudingBox = this.mapFunc.mapObj.getBoundingBox({EPSG: this.mapFunc.EPSG});
    if (this.mapFunc.minZoomAsset !== 0 && this.mapFunc.maxZoomAsset !== 0 &&
      (boudingBox == null || boudingBox.zoom < this.mapFunc.minZoomAsset
         || boudingBox.zoom > this.mapFunc.maxZoomAsset)) {
      return;
    }
    if (boudingBox == null) {
      return;
    }
    const coor = [boudingBox.minLon, boudingBox.maxLat];
    const coorNext = [boudingBox.maxLon, boudingBox.minLat];

    const fromSource = 'finish load tiles';
    // begin 15058#c57166 : 1) initialAssetLoading
    if (this.mapFunc.layerAssets.length > 0) {
      if (this.mapFunc.requestId) { clearTimeout(this.mapFunc.requestId); }
      this.mapFunc.requestId = null;
      this.mapFunc.isRequesting = true;

      // delete old feature from componentDefinition.layer & componentDefinition.filter
      for (let i = 1; i < this.mapFunc.mapObj.layerIndexFilter + 1; i++) {
        this.mapFunc.mapObj.clearAllFeaturesLayer(i);
      }

      this.mapFunc.countFinishQueries = 0;
      let layerIdx = -1;
      for (let i = 0; i < this.mapFunc.layerAssets.length; i++) {
        const isFilter = this.mapFunc.layerAssets[i].isFilter;
        const layer = this.mapFunc.layerAssets[i].layer;
        if (!isFilter) {
          layerIdx++;
        }

        if (layer.filter) {
          const newFilter = sclHandlebars.processHandlebars(layer.filter, null, null, null, this.mapFunc.contextParams);
          if (this.mapFunc.showTiming) {
            if (isFilter) {
              console.log(`%c from: ${fromSource}, <user_config>.filter
               start time search filter ${(new Date()).toISOString()}
               \n\t, query = ${newFilter}`, 'color:green');
            } else {
              console.log(`%c from: ${fromSource}
              , start time for all query layer ${(new Date()).toISOString()}`, 'color:green');
            }
          }

          let query = layer.filter + (isFilter ? '_filter': '_layer') + '_' + this.mapFunc.layerAssets[i].i;
          this.mapFunc.searchMultiAssetMove(fromSource, coor, coorNext, newFilter, layer.geoJsonField, layer,
            query, layer, {
              compType: MapComponentName.SELECTED_ASSET,
              layerDisplayOnly: layer.layerDisplayOnly,
            }, this.afterLoadSelectedAssetFnCb.bind(this, fromSource, i, isFilter));
        } else {
          this.mapFunc.countFinishQueries++;
          if (this.mapFunc.countFinishQueries === this.mapFunc.layerAssets.length) {
            if (this.mapFunc.showTiming) {
              if (isFilter) {
                console.log(`%c from: ${fromSource}, <user_config>.filter
                 end time search filter ${(new Date()).toISOString()}`, 'color:green');
              } else {
                console.log(`%c from: ${fromSource}, layer[${layerIdx}]
                 end time for all query layer ${(new Date()).toISOString()}`, 'color:green');
              }
            }
          }
        }
      }
    }
  }
  afterLoadSelectedAssetFnCb(fromSource, i, isFilter) {
    this.mapFunc.countFinishQueries++;
    if (this.mapFunc.countFinishQueries == this.mapFunc.layerAssets.length) {
      if (this.mapFunc.showTiming) {
          if (isFilter) {
          console.log(`%c from: ${fromSource}
           end time search filter ${(new Date()).toISOString()}`, 'color:green');
        } else {
          console.log(`%c from: ${fromSource}, layer[${i}]
          + ' end time for all query layer ${(new Date()).toISOString()}`, 'color:green');
        }
      }

      // begin 16411#c66133 : will unlock later
      // if (this.drawSelectAssetUIObj) {
      //   const feas = this.mapFunc.mapObj.getFeaturesCollectionId(this.drawSelectAssetUIObj.docId);
      //   console.log('docId = ' + this.drawSelectAssetUIObj.docId);
      //   console.log('feas = ' + feas);
      //   this.drawSelectAssetUI(this.drawSelectAssetUIObj.isPrimary, this.drawSelectAssetUIObj.tpl
      //     , this.drawSelectAssetUIObj.assets, this.drawSelectAssetUIObj.coor
      //     , this.drawSelectAssetUIObj.isSingleSelection, feas);
      //   this.drawSelectAssetUIObj = null; // reset
      // }
      // end 16411#c66133 : will unlock later
    }
  }
  addSelectedAsset(assets, icon, assetType) {
    let currentId = null; let idx = 0;
    for (let i = 0; i < assets.length; i++) {
      const asset = assets[i];

      //
      if (!asset.properties || !asset.properties.linkAssets || !asset.properties.linkAssets[0]
        || !asset.properties.linkAssets[0].documentId) {
          console.log(`the asset has no documentId or properties: `, asset);
          continue;
      }

      //
      if (currentId == null || currentId !== asset.properties.linkAssets[0].documentId) {
        idx = 0;
        currentId = asset.properties.linkAssets[0].documentId;
      }

      //
      if (asset.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
        if (Array.isArray(asset.geometries) === false) {
          console.log(`the asset has no geometry: `, asset);
          continue;  
        }

        const id = `${asset.properties.linkAssets[0].documentId}_${idx}`;
        // const id = `${asset.properties.linkAssets[0].documentId}_${idx}_${assetType}`;
        idx++;

        asset.type = FEATURE_TYPE.FEATURE;
        const properties = cloneDeep(asset.properties.linkAssets[0]);
        const radius = asset.properties.radius;

        properties.documentId = `${id}_${assetType}`;
        properties.assetType = assetType;

        if (assetType === MapSelectAssetType.PRIMARY) { 
          this.primaryAssets.push({id: `${id}_${assetType}`, asset }); 
        } else { 
          this.secondaryAssets.push({id: `${id}_${assetType}`, asset });
        }

        const name = asset.properties.linkAssets[0].name;
        
        
        for (let j = 0; j < asset.geometries.length; j++) {
          const geom = asset.geometries[j];
          
          const iId = `${id}_${j}_${assetType}`;
          
          let type = geom.type;
          let coorData = geom.coordinates;
          
          if (radius && this.mapLibName === MapLibraryName.GOOGLE) {
            // convert to polygon
            coorData = this.sclUtilMapService.circleToPolygon(coorData, radius);
            type = MapDrawType.POLYGON;

          }

          if (this.mapFunc.showTiming) {
            console.log(`start time add ${assetType} asset, id = ${id}, ${(new Date()).toISOString()}`);
          }

          const fIcon = this.mapFunc.mapObj.createFeatureByType(coorData, type
            , {EPSG: this.mapFunc.EPSG, imageFileNo: icon, name, iId, type, radius, circleCenter: null});

          

          this.mapFunc.mapObj.setFeatureId(fIcon, iId);
          this.mapFunc.mapObj.setFeatureProperties(fIcon, properties);


          this.mapFunc.mapObj.storeSelectedAssets(fIcon, (assetType === MapSelectAssetType.PRIMARY ? true : false) );

          if (this.mapFunc.showTiming) {
            console.log(`end time add ${assetType} asset, id = ${id} ${(new Date()).toISOString()}`);
          }
        }
        
      } else {
        if (!asset.geometry || !asset.geometry.type || !asset.geometry.coordinates) {
          console.log(`the asset has no geometry: `, asset);
          continue;
        }

        const id = `${asset.properties.linkAssets[0].documentId}_${idx}_${assetType}`;
        idx++;

        if (assetType === MapSelectAssetType.PRIMARY) { 
          this.primaryAssets.push({id, asset }); 
        } else { 
          this.secondaryAssets.push({id, asset }); 
        }

        const name = asset.properties.linkAssets[0].name;
        let type = asset.geometry.type;
        let coorData = asset.geometry.coordinates;
        const properties = cloneDeep(asset.properties.linkAssets[0]);
        const radius = asset.properties.radius;
        
        if (radius && this.mapLibName === MapLibraryName.GOOGLE) {
          // convert to polygon
          coorData = this.sclUtilMapService.circleToPolygon(coorData, radius);
          type = MapDrawType.POLYGON;

        }

        if (this.mapFunc.showTiming) {
          console.log(`start time add ${assetType} asset, id = ${id}, ${(new Date()).toISOString()}`);
        }

        const fIcon = this.mapFunc.mapObj.createFeatureByType(coorData, type
          , {EPSG: this.mapFunc.EPSG, imageFileNo: icon, name, id, type, radius, circleCenter: null});

        properties.documentId = id;
        properties.assetType = assetType;

        this.mapFunc.mapObj.setFeatureId(fIcon, id);
        this.mapFunc.mapObj.setFeatureProperties(fIcon, properties);


        this.mapFunc.mapObj.storeSelectedAssets(fIcon, (assetType === MapSelectAssetType.PRIMARY ? true : false) );

        if (this.mapFunc.showTiming) {
          console.log(`end time add ${assetType} asset, id = ${id} ${(new Date()).toISOString()}`);
        }
      }
      
      

      
    }

  }

  removeDraw() {
    const pointDraw = this.mapFunc.mapObj.getFeatureById('1');
    if (pointDraw) {
      this.mapFunc.mapObj.removeFeature(pointDraw);
    }
  }

  async selectAssetPopup() {
    this.mapFunc.isPopupRadioOpen = false;

    const id = this.keyName + 'popup';
    const assets = []; const selectedFeatures = [];
    const selectedAssetIds = [];
    const unSelectedAssetIds = [];
    const assetsCoord = [];
    const coor = this.mapFunc.mapObj.getLatLngFromPixel(this.mapFunc.pixelPopup);
    let street = null;
    let feaType = MapDrawType.LINE_STRING;

    const cboxes = document.getElementsByName(id);
    const len = cboxes.length;
    for (let i = 0; i < len; i++) {
      const iCb = cboxes[i] as HTMLInputElement;
      if (iCb.checked) {
        selectedAssetIds.push(iCb.value);
      } else {
        unSelectedAssetIds.push(iCb.value);
      }
    }
    let pro0;
    for (let i = 0; i < selectedAssetIds.length; i++) {
      const fea = this.mapFunc.mapObj.getFeatureById(selectedAssetIds[i]);
      if (fea) {
        let type = MapSelectAssetType.PRIMARY;
        const pro = this.mapFunc.mapObj.getFeatureProperties(fea, ['street', 'type', 'coorData', 'itemData'
        , 'primary', 'secondary']);
        const handlebarsContext = {
          results: [pro.itemData],
          resultsCount: 1,
          resultsIndex: 0,
          queryResultDocument: pro.itemData
        };
        if (this.isPrimaryAsset) {
          pro.primary = await this.handlebarAsset(handlebarsContext, this.primaryIcon
            , cloneDeep(this.primaryAssetSelection), true);
        } else if (this.isSecondaryAsset) {
          pro.secondary = await this.handlebarAsset(handlebarsContext, this.secondaryIcon
            , cloneDeep(this.secondaryAssetSelection), false);
        }

        if (i == 0) {
          pro0 = pro;
          pro0.id = selectedAssetIds[i];
          if (pro0.id.indexOf('_') > -1) { pro0.id = pro0.id.split('_')[0]; }
        }
        street = pro.street;
        feaType = pro.type;
        if (feaType === MapDrawType.POINT) {
          const loc = pro.coorData;
          assetsCoord.push(loc) ;
        } else {

          const nearestPoint = this.mapFunc.getNearestPoint(fea, coor);

          assetsCoord.push(nearestPoint);
        }

        if (this.isSecondaryAsset) {type = MapSelectAssetType.SECONDARY; }
        const asset = this.mapFunc.mapObj.getAssetProperties(fea, this.componentDefinition.relatedFields, assetsCoord[i], type);
        if (!asset) {return; }

        assets.push(asset);
        selectedFeatures.push( { feature: fea} );

        const options = { clickFeature: selectedFeatures, pixel: null, isClickMap: false
        , primary: pro.primary, secondary: pro.secondary, itemData: pro.itemData };




        if (this.isPrimaryAsset) {
          this.selectPrimaryAction(assets, unSelectedAssetIds, assetsCoord, this.singlePrimaryAssetSelection, street, options);
        } else if (this.isSecondaryAsset) {
          this.selectSecondaryAction(assets, unSelectedAssetIds, assetsCoord, this.singleSecondaryAssetSelection, street, options);
        }
      }
    }
    if (this.isPrimaryAsset && this.primaryAssetAddressLookup && pro0){
      if (this.primaryAssetAddressLookupPoint === 'clickPoint') {
        if (this.primaryAssetAddressLookupClickPoint == null) {
            console.error('Can not get address of point is null');
        } else {
          this.reverseAssetAddressLookup(this.primaryAssetAddressLookupClickPoint.lat,
            this.primaryAssetAddressLookupClickPoint.lng, pro0.id);
        }
      } else {
        const coor = this.sclUtilMapService.getCenterOfGeometry(pro0.coorData, pro0.type);
        this.reverseAssetAddressLookup(coor[1], coor[0], pro0.id);
      }
    }

    // reset asset popup content
    this.postList = [];//reset
    this.cdRef.detectChanges();
  }

  selectPrimary(tpl, model?) {
    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
    this.selectAssetUI(true, tpl, model);
  }
  selectSecondary(tpl, model?) {
    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
    this.selectAssetUI(false, tpl, model);
  }
  async selectAssetUI(isPrimary, tpl, model) {
    const isSingleSelection = (isPrimary ? this.singlePrimaryAssetSelection : this.singleSecondaryAssetSelection);
    let lst = (isPrimary ? this.assets.primary : this.assets.secondary);
    const idType = (isPrimary ? '_primary' : '_secondary');
    let obj: any = {
      type: FEATURE_TYPE.FEATURE,
      properties: tpl.properties
    };
    if (tpl.geometry) {
      obj.geometry = tpl.geometry;
    }



    if (isSingleSelection) {
      // remove old selected assets because allow just 1 (P/S) selected asset one time
      for (let i = 0; i < lst.length; i++) {
        const priAsset = lst[i];
        const docId = priAsset.properties.linkAssets[0].documentId + idType;
        this.mapFunc.mapObj.removeSelectedAssetsById(docId);
      }
      lst = [];
      lst.push(obj);
    }
    const docId = tpl.properties.linkAssets[0].documentId;
    const feas = this.mapFunc.mapObj.getFeaturesCollectionId(docId);
    let primary = null; let secondary = null; let itemData = null;
    if (feas && feas.length > 0) {
      const p = this.mapFunc.mapObj.getFeatureProperties(feas[0], ['primary', 'secondary', 'itemData']);
      const handlebarsContext = {
        results: [p.itemData],
        resultsCount: 1,
        resultsIndex: 0,
        queryResultDocument: p.itemData
      };
      p.primary = await this.handlebarAsset(handlebarsContext, this.primaryIcon
        , cloneDeep(this.primaryAssetSelection), true);

      p.secondary = await this.handlebarAsset(handlebarsContext, this.secondaryIcon
        , cloneDeep(this.secondaryAssetSelection), false);

      primary = p.primary; secondary = p.secondary; itemData = p.itemData;
    } else {
      const customData = [tpl];
      const handlebarsContext = {
        results: customData,
        resultsCount: customData.length,
        resultsIndex: 0,
        queryResultDocument: tpl
      };
      primary = await this.handlebarAsset(handlebarsContext, this.primaryIcon
        , cloneDeep(this.primaryAssetSelection), true);

      secondary = await this.handlebarAsset(handlebarsContext, this.secondaryIcon
        , cloneDeep(this.secondaryAssetSelection), false);
    }

    if (tpl.geometry) {
      const coor = this.sclUtilMapService.getCenterOfGeometry(tpl.geometry.coordinates, tpl.geometry.type); // [lon, lat]
      if ( (isPrimary && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT)
       || (!isPrimary && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT) ) {
        tpl.geometry.coordinates = coor;
      }
      obj = { geometry: { type : ''}, properties: {}, type: ''  };
      obj.geometry = tpl.geometry;
      obj.geometry.type = MapDrawType.POINT;
      obj.properties = tpl.properties;
      obj.type = FEATURE_TYPE.FEATURE; // tpl.type;
      const assets = [obj];


      if ( (isPrimary && this.primaryAssetSelectionMode === MapSelectAssetMode.ASSET)
       || (!isPrimary && this.secondaryAssetSelectionMode === MapSelectAssetMode.ASSET) ) {
        if (feas && feas.length > 0) {
          this.drawSelectAssetUI(isPrimary, tpl, assets, coor, isSingleSelection, feas, primary, secondary, itemData);
        } else {
            // what happen if this feature is not in current view port
            console.log(`the asset ${docId} does not present in current view port`);
            // begin 16411#c66133 : will unlock later
            // console.log(tpl);
            // if (this.searchAssetSelectionInclude) {
            //   // expand the view port
            //   console.log('expand the view port....');
            //   this.drawSelectAssetUIObj = {isPrimary, tpl, assets, coor, isSingleSelection, docId};
            //   this.mapFunc.mapObj.extendToCoordinate(tpl.geometry.coordinates);
            // }
            // end 16411#c66133 : will unlock later
        }
      } else {
        const options = { clickFeature: [], pixel: null, isClickMap: false, primary, secondary, itemData };
        if (isPrimary) {
          this.selectPrimaryAction(assets, '', [coor] , isSingleSelection, tpl.street, options);
        } else {
          this.selectSecondaryAction(assets, '', [coor] , isSingleSelection, tpl.street, options); }
      }
      // begin 15262
      if (this.moveToSelectedSearchAsset === true) {
        this.mapFunc.mapObj.setCenter(coor[1], coor[0]);
      }
      if (this.initialMapView.length === 0) { // make sure the 'initial map view' process complete
        this.isUpdateViewPort = false;
        this.onMoveEnd(null); // map will load asset after select asset event if initialAssetLoading = false
      }

      // end 15262

      // begin 15712
      if (isPrimary && this.primaryAssetAddressLookup) {
        this.latestAssetId = docId;
        this.reverseAssetAddressLookup(coor[1], coor[0], docId);
      }
      // end 15712
    } else {
      if (isPrimary) {
        const result = this.selectAssetUINoGeometry(lst, this.primaryAssets, obj, isSingleSelection);
        this.assets.primary = result.assets;
        this.primaryAssets = result.lstAsset;
        if (!result.isExists) {
          this.sAssetsPrimary = JSON.stringify(this.assets.primary);
          this.addHeader();
          this.updateValue();
          super.valueChanged(cloneDeep(this.mapFunc.featureCollections));
          this.setPrimaryScrollView();
        }
      } else {
        const result = this.selectAssetUINoGeometry(lst, this.secondaryAssets, obj, isSingleSelection);
        this.assets.secondary = result.assets;
        this.secondaryAssets = result.lstAsset;
        if (!result.isExists) {
          this.sAssetsSecondary = JSON.stringify(this.assets.secondary);
          this.addHeader();
          this.updateValue();
          super.valueChanged(cloneDeep(this.mapFunc.featureCollections));
          this.setSecondaryScrollView();
        }
      }

    }

  }
  drawSelectAssetUI(isPrimary, tpl, assets, coor, isSingleSelection, feas, primary, secondary, itemData) {
    const options = { clickFeature: [], pixel: null, isClickMap: false, primary, secondary, itemData };
    for (let i = 0; i < feas.length; i++) {
        if ( (isPrimary && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT)
          || (!isPrimary && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT) ) {
            this.mapFunc.mapObj.setFeatureProperties(feas[i], {coorData: tpl.geometry.coordinates});
        }

        options.clickFeature.push({feature: feas[i]});
    }

    if (isPrimary) {
      this.selectPrimaryAction(assets, '', [coor] , isSingleSelection, tpl.street, options);
    } else {
      this.selectSecondaryAction(assets, '', [coor] , isSingleSelection, tpl.street, options); }
  }
  selectAssetUINoGeometry(assets, lstAsset, selectedAsset, isSingleSelection) {
    let isExists = false;
    for (let i = 0; i < assets.length; i++) {
      if (assets[i].properties.linkAssets[0].documentId === selectedAsset.properties.linkAssets[0].documentId) {
        isExists = true;
        break;
      }
    }
    if (isSingleSelection) {
      isExists = false;
      assets = [];
      assets.push(selectedAsset);
      lstAsset = [{
        asset: selectedAsset,
        id: selectedAsset.properties.linkAssets[0].documentId
      }];
    } else if (!isExists) {
      assets.push(selectedAsset);
      lstAsset.push({
        asset: selectedAsset,
        id: selectedAsset.properties.linkAssets[0].documentId
      });
    }

    return {isExists, assets, lstAsset};
  }
  getObjectNotWildcardSummaryName(mustObject) {
    const mustSelected = [];
    mustObject.map((key, index) => {
      let isFoundSummaryName = false;
      if (key.wildcard) {
        for (const sss in key.wildcard) {
          if (sss === 'systemHeader.summaryName.lcase') {
            isFoundSummaryName = true;
          } else {
            isFoundSummaryName = false;
          }
        }
      } else {
        isFoundSummaryName = false;
      }
      if (!isFoundSummaryName) {
        mustSelected.push(mustObject[index]);
      }
    });
    return mustSelected;
  }

  // convert scope.searchAsset
  searchAssetUI(text, assetType) {
    let assetField; assetField = this.componentDefinition;
    if (this.mapFunc && this.mapFunc.geoAutoComplete != null && this.mapFunc.geoAutoComplete.mapGeo != null) {
      this.mapFunc.geoAutoComplete.mapGeo.removeFeatures();
    }

    if (this.mapGeo != null) { this.mapGeo.removeFeatures(); }

    const newText = text.trim();
    this.resultsPrimary = [];
    this.resultsSecondary = [];
    if (newText === this.preAssetText) {
      return;
    }
    if (text !== undefined && text.length >= this.searchMinLength) {
      this.preAssetText = text;
      this.inputText = text;
      let filter = null;
      let originFilter = '';
      let fromSource = 'unknown';
      if (assetType === MapSelectAssetType.PRIMARY) {
        if (assetField.primaryAssetFilter) {
          filter = sclHandlebars.processHandlebars(assetField.primaryAssetFilter, null
            , null, null, this.mapFunc.contextParams); // assetField.primaryAssetFilter;
        } else {
          console.error(`primaryAssetFilter is undefined`);
          return;
        }

        originFilter = assetField.primaryAssetFilter;
        fromSource = 'primaryFilter';
      } else if (assetType === MapSelectAssetType.SECONDARY) {
        if (assetField.secondaryAssetFilter) {
          filter = sclHandlebars.processHandlebars(assetField.secondaryAssetFilter, null
            , null, null, this.mapFunc.contextParams); // assetField.secondaryAssetFilter;
        } else {
          console.error(`secondaryAssetFilter is undefined`);
          return;
        }

        originFilter = assetField.secondaryAssetFilter;
        fromSource = 'secondaryFilter';
      }
      if (!filter) {
        this.preAssetText = ''; // reset
        return;
      }

      // check if filter is heatmap
      if (assetField.layers) {
        for (let i = 0; i < assetField.layers.length; i++) {
          if (typeof assetField.layers[i].filter === 'undefined') { continue; }
          let isHeatMap = false;
          if (typeof assetField.layers[i].type !== 'undefined' && assetField.layers[i].type.toLowerCase() === 'heatmap') {
            isHeatMap = true; }
          if (assetField.layers[i].filter === originFilter && isHeatMap) {
            this.preAssetText = ''; // reset
            console.log(`can not search with heatmap`);
            return; // then not allow search
          }
        }
      }

      filter = sclHandlebars.processHandlebars(filter, null, null, null, this.mapFunc.contextParams);
      if (typeof filter === 'string') {
        filter = filter.replace(/'/g, '"');
      }
      // begin 15263
      const filterObj = JSON.parse(filter);
      if (filterObj.query.bool.should === undefined) {
        filterObj.query.bool.should = [];
      }
      if (filterObj.query.bool.must instanceof Object && filterObj.query.bool.must.constructor === Object){
        const objMust = filterObj.query.bool.must;
        filterObj.query.bool.must = [];
        filterObj.query.bool.must.push(objMust);
      } else {
        if (filterObj.query.bool.must === undefined) {
           filterObj.query.bool.must = [];
        }
      }
      filterObj.query.bool.must = this.getObjectNotWildcardSummaryName(filterObj.query.bool.must);
      filterObj.query.bool.must.push({wildcard: {'systemHeader.summaryName.lcase': '*' + text.toLowerCase() + '*'}});
      filter = JSON.stringify(filterObj);
      // end 15263
      let geoJsonFieldMode = this.geoJsonField;
      if (assetType === MapSelectAssetType.PRIMARY && assetField.primaryGeoJsonField) {
        geoJsonFieldMode = assetField.primaryGeoJsonField;
      } else if (assetType === MapSelectAssetType.SECONDARY && assetField.secondaryGeoJsonField) {
        geoJsonFieldMode = assetField.secondaryGeoJsonField;
      }
      let options;
      options = {
        page: 0,
        pageSize: 100,
        document: this.document,
        filter,
        assetType
      };
      options.sourceFilter = [geoJsonFieldMode , 'documentId', 'systemHeader.summaryName'];
      if (this.mapFunc.primaryAssetAddressField) {
        options.sourceFilter.push(this.mapFunc.primaryAssetAddressField);
      }
      if (this.mapFunc.primaryAssetGeometryField) {
        options.sourceFilter.push(this.mapFunc.primaryAssetGeometryField);
      }
      if (this.mapFunc.secondaryAssetAddressField) {
        options.sourceFilter.push(this.mapFunc.secondaryAssetAddressField);
      }
      if (this.mapFunc.secondaryAssetGeometryField) {
        options.sourceFilter.push(this.mapFunc.secondaryAssetGeometryField);
      }
      if (typeof assetField.tooltips !== undefined && assetField.tooltips !== null && assetField.tooltips !== undefined) {
        const sf = this.getHandlerValue(assetField.tooltips);
        if (sf.length > 0) {
          for (let i = 0; i < sf.length; i++) {
            if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
          }
        }
      }
      if (this.mapFunc.relatedAssetQuery.length > 0) {
        for (let i = 0; i < this.mapFunc.relatedAssetQuery.length; i++) {
          if (options.sourceFilter.indexOf(this.mapFunc.relatedAssetQuery[i]) < 0) {
            options.sourceFilter.push(this.mapFunc.relatedAssetQuery[i]);
          }
        }
      }

      // Adding manual addition of fields to retrieve in queries to handle complex handlebar requirements
      // supported for overall component in root config
      if (typeof assetField.additionalQueryFields !== undefined && assetField.additionalQueryFields !== null &&
        assetField.additionalQueryFields !== undefined) {
        const sf = assetField.additionalQueryFields;
        if (sf.length > 0) {
          for (let i = 0; i < sf.length; i++) {
            if (options.sourceFilter.indexOf(sf[i]) < 0) { options.sourceFilter.push(sf[i]); }
          }
        }
      }

      if (this.mapFunc.showTiming) {
        console.log(`start time search asset from ${fromSource} : ${(new Date()).toISOString()}
        \n\t, query = ${options.filter}`);
      }

      if (assetField.primaryAssetQueryName) {
        options.dataSource =  this.searchClientService.getDefaultSearchProvider(this);
        options.queryName = assetField.primaryAssetQueryName;
      }

      if (assetType === MapSelectAssetType.SECONDARY) {
        if (assetField.dexieSearchSecondaryAssetFilter) {
          options.searchOptions = this.sclUtilMapService.dexieSearchFunction(assetField.dexieSearchSecondaryAssetFilter,
            options.page, options.pageSize);
        } else if (assetField.secondaryAssetQueryName) {
          options.dataSource =  this.searchClientService.getDefaultSearchProvider(this);
          options.queryName = assetField.secondaryAssetQueryName;
        }
      }

      if (this.searchClientService.isDexieQuery(this, options.queryName)) {
        filter = JSON.parse(options.filter);
        filter.dexieQuery = [{ field: 'systemHeader.summaryName', value: text.toLowerCase(),
          operator: SclSearchClientConstantService.operator.contains}];
        options.filter = filter;
      }

      options.searchOfflineOnly = this.componentDefinition?.searchOptions?.searchOfflineOnly;

      this.searchClientService.search(options).then((results) => {
        this.preAssetText = ''; // reset
        if (options.assetType === MapSelectAssetType.SECONDARY) {
          this.resultsSecondary = []; // reset
        } else if (options.assetType === MapSelectAssetType.PRIMARY) {
          this.resultsPrimary = []; // reset
        }

        if (this.mapFunc.showTiming) {
          console.log(`end time search asset from ${fromSource}: ${(new Date()).toISOString()}`);
        }

        SearchResultsProcessor.processSearchResultsParallel(results, (itemData) => {
          if (!itemData) { return; }
          // elementProcessingCallbacks

          let addressField = geoJsonFieldMode;
          if (assetType === MapSelectAssetType.SECONDARY) {
            if (this.mapFunc.secondaryAssetAddressField) {
              addressField = this.mapFunc.secondaryAssetAddressField;
            }
            const asset = this.sclAssetLayersService.getAssetPoint(itemData, assetField, MapSelectAssetType.SECONDARY,
            addressField, assetField.secondaryAssetAddressSelection);

            const geometryAsset = (this.mapFunc.secondaryAssetGeometryField ?
              itemData[this.mapFunc.secondaryAssetGeometryField] : itemData[geoJsonFieldMode]);

            if (geometryAsset) {
              asset.geometry = geometryAsset.features[0].geometry;
            }

            this.resultsSecondary.push(asset);
          } else {
            if (this.mapFunc.primaryAssetAddressField) {
              addressField = this.mapFunc.primaryAssetAddressField;
            }
            const asset = this.sclAssetLayersService.getAssetPoint(itemData, assetField, MapSelectAssetType.PRIMARY,
              addressField, assetField.primaryAssetAddressSelection);
            const geometryAsset = (this.mapFunc.primaryAssetGeometryField ?
              itemData[this.mapFunc.primaryAssetGeometryField] : itemData[geoJsonFieldMode]);

            if (geometryAsset) {
              asset.geometry = geometryAsset.features[0].geometry;
            }

            this.resultsPrimary.push(asset);
          }
        }, () => {
            // completionCallback
            // console.log('the "processSearchResultsParallel" is complete');
        });


        this.cdRef.detectChanges();

      }, (err) => {
        this.preAssetText = ''; // reset
        if (this.mapFunc.showTiming) {
          console.log(`(error) end time search asset from ${fromSource}: ${(new Date()).toISOString()}`);
        }
        console.log(`error in Search Address search:`, err);
      });
    }
  }

  testSearchUI(text, jsonObj) {
    const r = [];
    for (let i = 0; i < jsonObj.length; i++) {
      if (jsonObj[i]._source.systemHeader.summaryName.toLowerCase().indexOf(text) > -1) {
        r.push(jsonObj[i]);
      }
    }
    return r;
  }

  displayAsset(type) {
    return (val) => '';
  }

  async selectAction(scopeAsset, sType, assetAddressSelection, assets, unSelectedAssetIds, coordinate, singleSelection, street, clickedObj) {
    if (scopeAsset === undefined) {
      scopeAsset = [];
    }

    if (assetAddressSelection) {
      if (street) {
        const st: any = new AddressDetails();
        if (street.properties) {
          this.resetAddressData();
          st.properties.streetNo = street.properties.streetNo;
          st.properties.street = street.properties.street;
          st.properties.suburb = street.properties.suburb;
          st.properties.postcode = street.properties.postcode;
          st.properties.country = street.properties.country;
          st.properties.state = street.properties.state;
        }

        if (street.geometry) {
          const coordinates = street.geometry.coordinates;
          const lat = parseFloat(coordinates[1]);
          const lon = parseFloat(coordinates[0]);
          st.geometry.coordinates[0] = lon;
          st.geometry.coordinates[1] = lat;

          this.updateMap(lat, lon, false, true);
        }
        if (this.streetDataComp) {
          this.streetDataComp.streetDataStr = JSON.stringify(st);
        }
        this.updateChange();
      }
    }

    if (unSelectedAssetIds) {this.mapFunc.mapObj.removeUnselectedAsset(scopeAsset, unSelectedAssetIds, sType); }

    if (assets == null || assets.length <= 0) { return; }

    // begin 14502
    if (this.clickPoint) {
      const coor = [this.clickPoint.lng, this.clickPoint.lat];
      this.switchPrimaryAssetAddressLookUp(false);
      if (this.mapFunc && this.mapFunc.geoAutoComplete != null && this.mapFunc.geoAutoComplete.mapGeo != null) {
        this.mapFunc.geoAutoComplete.mapGeo.reverse( coor, (streetData, obj) => {
          if (streetData == null ) { return; }
          this.getRelatedDocument(streetData);
          if (streetData.geometry && (streetData.geometry.coordinates[0] !== this.clickPoint.lng ||
            streetData.geometry.coordinates[1] !== this.clickPoint.lat) ) {
            console.log(`street data return is not latest click point`);
            return;
          }
          streetData.geometry.coordinates[0] = obj.lng;
          streetData.geometry.coordinates[1] = obj.lat;
          if (this.streetDataComp) {
            this.streetDataComp.streetData[this.keyName] = streetData;
          }
          this.mapFunc.mapObj.updateLocation(obj.lat, obj.lng, this.mapFunc.addressId, this.addressMarker
            , 'address', this.mapFunc.addressId, true);
          this.updateChange();
          this.resetPostionMandatory();
        }
        , (err) => {
          if (err && this.mapFunc.isOnline === true) {
            this.notificationService.error(err);
          }
          this.updateChange();
        });
      } else {
        console.log(`Can\'t get address because reverse service is NULL`);
      }
    }
    // end 14502

    if (singleSelection) {
      for (let i = 0; i < scopeAsset.length; i++) {
        const priAsset = scopeAsset[i];
        const docId = priAsset.properties.linkAssets[0].documentId + '_' + sType;
        this.mapFunc.mapObj.removeSelectedAssetsById(docId);
        this.removeAssetSelected(sType, priAsset.properties.linkAssets[0].documentId);
      }
      scopeAsset = [];
      let selectAsset;
      for (let i = 0; i < assets.length; i++) {
        const asset = assets[i];
        if (asset.geometry && asset.geometry.type && asset.geometry.type === MapDrawType.POINT) {
            selectAsset = asset;
            break;
        }
        selectAsset = asset;
      }
      if (!selectAsset) {return; }
      if (!this.mapFunc.isContainAsset(selectAsset, scopeAsset)) {
        scopeAsset.push(selectAsset);
        this.latestAssetId = selectAsset.properties.linkAssets[0].documentId;
        if (sType === MapSelectAssetType.PRIMARY) {
          await this.addPrimaryIcon(selectAsset, coordinate[0], clickedObj, true);
          this.assets.primary = scopeAsset;
        } else if (sType === MapSelectAssetType.SECONDARY) {
          await this.addSecondaryIcon(selectAsset, coordinate[0], clickedObj, true);
          this.assets.secondary = scopeAsset;
        }
      }
    } else {
      this.latestAssetId = assets[assets.length - 1].properties.linkAssets[0].documentId;
      for (let i = 0; i < assets.length; i++) {
        const asset = assets[i];
        const assetId = asset.properties.linkAssets[0].documentId;
        let idA = assetId;
        if (idA.indexOf('_') > -1) { idA = idA.split('_')[0]; }
        // this code for move asset position on same asset
        if (assets.length === 1) {
          for (let j = 0; j < scopeAsset.length; j++) {
            const item = scopeAsset[j];
            const id = item.properties.linkAssets[0].documentId;
            const idB = (id.indexOf('_') > -1 ? id.split('_')[0] : id);
            if (idB === idA) {
              for (let k = 0; k < this.mapFunc.mapObj.selectedAssets.length; k++) {
                const kId = this.mapFunc.mapObj.getFeatureId(this.mapFunc.mapObj.selectedAssets[k]);
                const kType = this.mapFunc.mapObj.getFeatureProperty(this.mapFunc.mapObj.selectedAssets[k], 'assetType');

                if (kId.indexOf(idA) > -1 && kType === sType && kId !== assetId ) {
                  this.mapFunc.mapObj.removeItemFromMap(kId);
                }
              }
              scopeAsset.splice(j, 1);
              break;
            }
          }
        }

        if (!this.mapFunc.isContainAsset(asset, scopeAsset)) {
          scopeAsset.push(asset);

          if (sType === MapSelectAssetType.PRIMARY) {
            await this.addPrimaryIcon(asset, coordinate[i], clickedObj, false);
          } else if(sType === MapSelectAssetType.SECONDARY) {
            await this.addSecondaryIcon(asset, coordinate[i], clickedObj, false);
          }
        }
      }
    }

    return scopeAsset;
  }
  getOuterHeight(element) {
    let h = element.offsetHeight;
    const style = window.getComputedStyle(element);
    h += Number(style.marginTop.replace('px', '')) ;
    h += Number(style.marginBottom.replace('px', ''));

    return h;
  }
  setScrollView(assets, elementTarget, selectionRows, scrollViewInterval) {
    if (assets.length > selectionRows) {
      elementTarget.style['overflow-y'] = 'scroll';
      elementTarget.style['margin-bottom'] = '15px'; // can click arrow bottom of the scrollbar
      let h = 0;
      if (!scrollViewInterval) {
        scrollViewInterval = setInterval(() => {
          if ( assets.length > 0 && elementTarget.children && elementTarget.children.length > 0) {
            clearInterval(scrollViewInterval);
            scrollViewInterval = null;

            for (let i = 0; i < selectionRows; i++) {
              if (elementTarget.children[i]) {
                h += elementTarget.children[i].offsetHeight;
              }
            }

            elementTarget.style.height = h + 'px';
          } else {
            console.log(`Waiting for loading primary asset DOM`);
          }
        }, 200);
      }


    } else {
      elementTarget.style.removeProperty('overflow-y');
      elementTarget.style.removeProperty('margin-bottom');
      elementTarget.style.height = 'auto';
    }
    return scrollViewInterval;
  }
  setPrimaryScrollView() {
    if (this.primarySelectionRows > 0 && this.dvPrimarySelection && this.dvPrimarySelection.nativeElement ) {
      this.scrollViewIntervalPrimary = this.setScrollView(this.assets.primary, this.dvPrimarySelection.nativeElement
        , this.primarySelectionRows, this.scrollViewIntervalPrimary);
      this.cdr.detectChanges();
    }
  }
  async selectPrimaryAction(assets, unSelectedAssetIds, coordinate, singleSelection, street, clickedObj) {
    const astPrimary = await this.selectAction(this.assets.primary, MapSelectAssetType.PRIMARY
      , this.componentDefinition.primaryAssetAddressSelection, assets, unSelectedAssetIds
      , coordinate, singleSelection, street, clickedObj);
    astPrimary.forEach((ast) => {
      if (ast.properties.linkAssets[0].documentId.indexOf('_') > -1) {
        ast.properties.linkAssets[0].documentId = ast.properties.linkAssets[0].documentId.split('_')[0];
      }
    });
    this.assetsPrimary = JSON.stringify(astPrimary);
    // this.updateChange(); // 15690
    this.valueChanged(cloneDeep(this.mapFunc.featureCollections));
  }
  setSecondaryScrollView() {
    if (this.secondarySelectionRows > 0 && this.dvSecondarySelection && this.dvSecondarySelection.nativeElement ) {
      this.scrollViewIntervalSecondary = this.setScrollView(this.assets.secondary, this.dvSecondarySelection.nativeElement
        , this.secondarySelectionRows, this.scrollViewIntervalSecondary);
      this.cdr.detectChanges();
    }
  }
  async selectSecondaryAction(assets, unSelectedAssetIds, coordinate, singleSelection, street, clickedObj) {
    const astSecondary = await this.selectAction(this.assets.secondary, MapSelectAssetType.SECONDARY
      , this.componentDefinition.secondaryAssetAddressSelection, assets, unSelectedAssetIds, coordinate
      , singleSelection, street, clickedObj);
    astSecondary.forEach((ast) => {
      if (ast.properties.linkAssets[0].documentId.indexOf('_') > -1) {
        ast.properties.linkAssets[0].documentId = ast.properties.linkAssets[0].documentId.split('_')[0];
      }
    });
    this.assetsSecondary = JSON.stringify(astSecondary);
    this.updateChange(); // 15690
  }
  // 15690
  updateChange() {
    this.valueChanged(cloneDeep(this.mapFunc.featureCollections));

    this.detectDocChange(this.fieldValue);
    this.cdRef.detectChanges();
  }

  // get the feature and existedFeature for every click in map
  findFeatureByClick(evt, assetType, sType) {
    const obj = this.mapFunc.mapObj.findFeatureByClick(evt, assetType, this.assetSelectionsAvailable, sType);
    const coor = obj.coor;
    const pixel = obj.pixel;
    const features = obj.features;
    let existedFeature = obj.existedFeature;
    for (let i = features.length - 1; i > -1; i--) {
      const id = this.mapFunc.mapObj.getFeatureId(features[i]);
      if (existedFeature == null) {
        if (id.indexOf(assetType) > -1) {
            existedFeature = features[i];
        }
      }
      if (id.indexOf(assetType) > -1) {
        features.splice(i, 1);
      }
    }

    return { features, existedFeature, coor, pixel };
  }
  async assetAction(evt, scopeAsset, assetType, selectActionF, singleSelection, sType ) {
    const obj = this.findFeatureByClick(evt, assetType, sType);
    let features = obj.features;
    let existedFeatures = [];
    if (obj.existedFeature){ existedFeatures = obj.existedFeature; }
    if (!Array.isArray(existedFeatures)){ existedFeatures = [existedFeatures]; }
    const coor = obj.coor; const pixel = obj.pixel;
    const assetsCoord = [];
    let street = null;

    // 15141#c57728
    // if ( (sType === 'primary' && this.primaryAssetSelectionMode === 'Asset') || (sType === 'secondary' &&
    //   this.secondaryAssetSelectionMode === 'Asset') ) {
    if (existedFeatures.length > 0) {
      for (let i = 0; i < existedFeatures.length; i++) {
        const existedFeature = existedFeatures[i];
        const existedAsset = this.mapFunc.mapObj.getAssetProperties(existedFeature
          , this.componentDefinition.relatedFields, coor, assetType);
        const exist = this.mapFunc.mapObj.removeUnselectedAssetItem(existedAsset, scopeAsset, assetType);
        const existId = existedAsset.properties.linkAssets[0].documentId;
        this.removeAssetSelected(assetType, existId);

        if (existId) {
          this.mapFunc.mapObj.removeSelectedAssetsById(existId);
          if ((assetType === MapSelectAssetType.PRIMARY
             && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT)
              || (assetType === MapSelectAssetType.SECONDARY
                 && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT)) {
            const f = this.mapFunc.mapObj.getFeatureById(existId);
            if (f) {
              this.mapFunc.mapObj.removeFeature(f);
            }
          }
        }

        if (exist) {
          this.updateValue();
          this.valueChanged(cloneDeep(this.mapFunc.featureCollections));
          this.cdRef.detectChanges();
          return;
        }
      }
      this.cdRef.detectChanges();
    }

    if (features.length === 0 && existedFeatures.length > 0) {
      let existCount = 0;
      for (let i = 0; i < existedFeatures.length; i++) {
        const existedFeature = existedFeatures[i];
        const existedAsset = this.mapFunc.mapObj.getAssetProperties(existedFeature
          , this.componentDefinition.relatedFields, coor, assetType);
        const exist = this.mapFunc.mapObj.removeUnselectedAssetItem(existedAsset, scopeAsset, assetType);
        const existId = existedAsset.properties.linkAssets[0].documentId;
        this.removeAssetSelected(assetType, existId);
        if (exist) { existCount++; }
        if (existId) {
          this.mapFunc.mapObj.removeSelectedAssetsById(existId);
          if ((assetType === MapSelectAssetType.PRIMARY
             && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT)
              || (assetType === MapSelectAssetType.SECONDARY
                 && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT)) {
            const f = this.mapFunc.mapObj.getFeatureById(existId);
            if (f) {
              this.mapFunc.mapObj.removeFeature(f);
            }
          }
        }
      }

      if (existCount > 0) {
        this.updateValue();
        this.valueChanged(cloneDeep(this.mapFunc.featureCollections));
        this.cdRef.detectChanges();
        return;
      }
    }
    if (features.length === 0 ) { return; }
    const lstAddressIndex = [];
    for (let i = 0; i < features.length; i++) {
      const p = this.mapFunc.mapObj.getFeatureProperties(features[i], ['id', 'name', 'street', 'type', 'coorData'
      , 'isCluster', 'radius', 'sharedId']);
      if ((p.id && p.id.indexOf('address') > -1) || (p.name && p.name.indexOf('address') > -1) ) {
        if (lstAddressIndex.indexOf(i) < 0) {
          lstAddressIndex.push(i);
        }
        continue;
      } else {
        street = p.street;

        const iType = p.type;
        if (iType === MapDrawType.POINT && !p.isCluster && !p.radius && (typeof p?.sharedId === 'string')) {
          assetsCoord.push(p.coorData) ;
        } else {
          assetsCoord.push(coor);
        }
        

      }
    }
    // remove feature is address
    for(var i = 0; i < lstAddressIndex.length; i++) {
      features.splice(lstAddressIndex[i], 1);
    }
    if(features.length == 0 ) return;

    // check if features has sharedId
    let hasSharedId = false;
    for(let i = 0; i < features.length; i++) {
      const iSharedId = this.mapFunc.mapObj.getFeatureProperty(features[i], 'sharedId');
      if (typeof iSharedId === 'string') {
        hasSharedId = true;
        break;
      }
    }
    

    if (this.popupAssetSelection && features.length > 1 && hasSharedId === false) {
      this.getHTMLTooltip(features, scopeAsset, null);
      this.setTooltipRadioPosition(pixel);
      const htmlText = this.getHTMLTooltip(features, scopeAsset, null);
    } else {// features.length > 1 && hasSharedId === true
      let existCount = 0;
      if (existedFeatures.length > 0) {
        for (let i = 0; i < existedFeatures.length; i++) {
          const existedFeature = existedFeatures[i];
          const existedAsset = this.mapFunc.mapObj.getAssetProperties(existedFeature, this.componentDefinition.relatedFields
            , coor, assetType);
          const exist = this.mapFunc.mapObj.removeUnselectedAssetItem(existedAsset, scopeAsset, assetType);
          if (this.mapLibName === MapLibraryName.GOOGLE) {
            let existedId = this.mapFunc.mapObj.getFeatureId(existedFeature);
            if (existedId.indexOf('_') > -1) { existedId = existedId.split('_')[0]; }
            for (let i = 0; i < features.length; i++) {
              const fId = this.mapFunc.mapObj.getFeatureId(features[i]);
              if (fId.indexOf(existedId) > -1 && ( ( assetType === MapSelectAssetType.PRIMARY && fId.indexOf('primary') > -1 ) ||
                ( assetType === MapSelectAssetType.SECONDARY && fId.indexOf('secondary') > -1 ) )  ) {
                  break;
                }
            }

          } else {
            if (exist) {
              existCount++;
            }
          }
        }
        if (existCount > 0) {
          return;
        }

      }
      const assets = this.mapFunc.mapObj.parseAssetsFromFeatures(features, this.componentDefinition, assetsCoord
        , assetType);
      if (Array.isArray(assets) && assets.length > 0 
         && assets[0] && typeof assets[0].properties === 'object'
         && assets[0].properties !== null && Array.isArray(assets[0].properties.linkAssets)
         && assets[0].properties.linkAssets.length > 0) {
        
        this.removeAssetSelected(assetType, assets[0].properties.linkAssets[0].documentId);
        assets[0].properties.linkAssets[0].documentId = assets[0].properties.linkAssets[0].documentId.
        replace('_primary', '').replace('_secondary', '');
      }
      const p = this.mapFunc.mapObj.getFeatureProperties(features[0], ['type', 'coorData', 'id', 'primary', 'secondary', 'itemData']);


      const handlebarsContext = {
        results: [p.itemData],
        resultsCount: 1,
        resultsIndex: 0,
        queryResultDocument: p.itemData
      };
      if (assetType === MapSelectAssetType.PRIMARY) {
        p.primary = await this.handlebarAsset(handlebarsContext, this.primaryIcon
          , cloneDeep(this.primaryAssetSelection), true);
      }

      if (assetType === MapSelectAssetType.SECONDARY) {
        p.secondary = await this.handlebarAsset(handlebarsContext, this.secondaryIcon
          , cloneDeep(this.secondaryAssetSelection), false);
      }


      const options = { clickFeature: (this.mapLibName === MapLibraryName.OPEN_LAYER ? null : evt.clickFeature )
        , pixel: (this.mapLibName === MapLibraryName.OPEN_LAYER ? pixel : null), isClickMap: true
        , primary: p.primary, secondary: p.secondary, itemData: p.itemData };
      if (assetType === MapSelectAssetType.PRIMARY && this.primaryAssetAddressLookup) {

        if (p.id.indexOf('_') > -1) { p.id = p.id.split('_')[0]; }
        if (this.primaryAssetAddressLookupPoint === 'clickPoint') {
          if (this.primaryAssetAddressLookupClickPoint == null) {
              console.error('Can not get address of point is null');
          } else {
            this.reverseAssetAddressLookup(this.primaryAssetAddressLookupClickPoint.lat,
              this.primaryAssetAddressLookupClickPoint.lng, p.id);
          }
        } else {
          const coor = this.sclUtilMapService.getCenterOfGeometry(p.coorData, p.type);
          this.reverseAssetAddressLookup(coor[1], coor[0], p.id);
        }
      }

      selectActionF(assets, '', assetsCoord, singleSelection, street, options);

    }
  }
  primaryAssetAction(evt) {
    this.assetAction(evt, this.assets.primary, MapSelectAssetType.PRIMARY
      , this.selectPrimaryAction.bind(this), this.singlePrimaryAssetSelection, 'primary');
  }
  secondaryAssetAction(evt) {
    this.assetAction(evt, this.assets.secondary, MapSelectAssetType.SECONDARY
      , this.selectSecondaryAction.bind(this), this.singleSecondaryAssetSelection, 'secondary');
  }
  addIcon( asset, coordinate, icon, assetType, clickedObj ) {
    const assetId = asset.properties.linkAssets[0].documentId + '_' + assetType;
    const name = asset.properties.linkAssets[0].name;
    let proPrimary = null; let proSecondary = null;
    if (clickedObj && clickedObj.primary) { proPrimary = clickedObj.primary; }
    if (clickedObj && clickedObj.secondary) { proSecondary = clickedObj.secondary; }

    if ( (assetType === MapSelectAssetType.PRIMARY
       && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT) ||
      (assetType === MapSelectAssetType.SECONDARY
         && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT) ) {
      const fIcon =  this.mapFunc.mapObj.createFeatureByType(coordinate, MapDrawType.POINT
        , {image: icon, name, id: assetId, EPSG: this.mapFunc.EPSG });
      this.mapFunc.mapObj.setFeatureId(fIcon, assetId);
      this.mapFunc.mapObj.setFeatureProperties(fIcon, { id: assetId, assetType, type: MapDrawType.POINT, coorData: coordinate
      , primary: proPrimary, secondary: proSecondary });
      this.mapFunc.mapObj.storeSelectedAssets(fIcon, (assetType === MapSelectAssetType.PRIMARY ? true : false) );
    } else {
      let options = {}; let lstFeature = [];
      if (clickedObj) {
        if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
            if (clickedObj.isClickMap) {
              options = { pixel: clickedObj.pixel, mode: 'all'};
              lstFeature = this.mapFunc.mapObj.getFeaturesCollection(options);
            } else {
              lstFeature = clickedObj.clickFeature;
            }
          } else {
            if (clickedObj.isClickMap) {
              options = { feature: clickedObj.clickFeature};
              lstFeature = this.mapFunc.mapObj.getFeaturesCollection(options);
            } else {
              lstFeature = clickedObj.clickFeature;
            }
          }
      }

      if (lstFeature.length > 0) {
        for (let i = 0; i < lstFeature.length; i++) {
          const f = lstFeature[i];
          //
          let iId = this.mapFunc.mapObj.getFeatureId(f.feature);
          if ( (iId.indexOf('secondary') > -1 && assetType === MapSelectAssetType.PRIMARY)
           || (iId.indexOf('primary') > -1 && assetType === MapSelectAssetType.SECONDARY) ) {
            continue;
          }
          if (iId.indexOf('_') > -1 ) {
            iId = iId.split('_')[0];
          }
          if (assetId.indexOf(iId) < 0) {
            continue;
          }
          //
          let type = this.mapFunc.mapObj.getFeatureGeomType(f.feature);
          if (type == MapDrawType.CIRCLE) { type = MapDrawType.POINT; }
          let propertyFields = ['coorData', 'radius', 'circleCenter', 'sharedId'];
          if (this.mapFunc.relatedAsset) {
            for (const field in this.mapFunc.relatedAsset) {
              if (this.mapFunc.relatedAsset.hasOwnProperty(field)) {
                const fieldAsset = this.mapFunc.relatedAsset[field];
                propertyFields.push(fieldAsset);
              }
            }
          }

          const p = this.mapFunc.mapObj.getFeatureProperties(f.feature
            , propertyFields);
          const coorData = p.coorData;
          if (coorData == null) {
            continue;
          }
          let fIcon; let id;
          id = this.mapFunc.mapObj.getFeatureId(f.feature) + '_' + assetType;
          // if this id was add before then go to next id
          if (this.checkDuplicateAssetIcon(( assetType === MapSelectAssetType.PRIMARY
             ? this.primaryAssets : this.secondaryAssets ), id)) { continue; }
          fIcon = this.mapFunc.mapObj.createFeatureByType(coorData, type
            , {EPSG: this.mapFunc.EPSG, image: icon, name, id, radius: p.radius, circleCenter: p.circleCenter});
          if (this.mapFunc.relatedAsset) {
            let propertyOfRelatedAsset = {};
            for (const field in this.mapFunc.relatedAsset) {
              if (p[field]) {
                propertyOfRelatedAsset[field] = p[field];
              }
            }
            this.mapFunc.mapObj.setFeatureProperties(fIcon, propertyOfRelatedAsset );
          }

          this.mapFunc.mapObj.setFeatureId(fIcon, id);
          this.mapFunc.mapObj.setFeatureProperties(fIcon, {id, assetType, type, coorData: coordinate
            , primary: proPrimary, secondary: proSecondary });
          this.mapFunc.mapObj.storeSelectedAssets(fIcon, (assetType === MapSelectAssetType.PRIMARY ? true : false) );

          const ast = this.mapFunc.mapObj.parseAssetsFromFeatures(fIcon, this.componentDefinition, coorData
            , assetType, (assetType === MapSelectAssetType.PRIMARY ? this.primaryAssetSelectionMode : this.secondaryAssetSelectionMode) );

          this.mapFunc.mapObj.setFeatureProperties(fIcon, ast.properties.linkAssets[0]);
          this.mapFunc.mapObj.setFeatureProperties(fIcon, {assetType, coorData: coordinate});

          const isPrimary = assetType === MapSelectAssetType.PRIMARY;
          const targetAssets = isPrimary ? this.primaryAssets : this.secondaryAssets;

          if (typeof p.sharedId === 'string') {
            const existing = targetAssets.find(item => item.id.indexOf(p.sharedId) > -1);
            if (!existing) {
              ast.geometries = [ast.geometry];
              delete ast.geometry;
              targetAssets.push({ id, asset: ast });
            } else {
              existing.asset.geometries.push(ast.geometry);
            }
          } else {
            targetAssets.push({ id, asset: ast });
          }
        }
      }
    }
  }
  

  checkDuplicateAssetIcon(lst, id) {
    let isExist = false;
    for (let i = 0; i < lst.length; i++) {
      if (lst[i].id === id) {
          isExist = true;
          break;
      }
    }
    return isExist;
  }



  async addPrimaryIcon(asset, coordinate, clickedObj, updateCoordinate) {
    if ( this.mapLibName === MapLibraryName.GOOGLE && updateCoordinate === true) {
      // const feature = (this.mapLibName === MapLibraryName.GOOGLE ? clickedObj.clickFeature : clickedObj.clickFeature[0].feature);
      const nearestPoint = this.mapFunc.getNearestPoint(clickedObj.clickFeature, coordinate);
      coordinate = nearestPoint;
      asset.geometry.coordinates = coordinate;
    }

    this.addIcon( asset, coordinate, this.primaryIcon, MapSelectAssetType.PRIMARY, clickedObj);
  }

  async addSecondaryIcon(asset, coordinate, clickedObj, updateCoordinate) {
    if ( this.mapLibName === MapLibraryName.GOOGLE && updateCoordinate === true) {
      // const feature = (this.mapLibName === MapLibraryName.GOOGLE ? clickedObj.clickFeature : clickedObj.clickFeature[0].feature);
      const nearestPoint = this.mapFunc.getNearestPoint(clickedObj.clickFeature, coordinate);
      coordinate = nearestPoint;
      asset.geometry.coordinates = coordinate;
    }

    this.addIcon( asset, coordinate, this.secondaryIcon, MapSelectAssetType.SECONDARY, clickedObj);
  }

  resetAddressData() {
    if (this.streetDataComp && this.streetDataComp.streetData[this.keyName]) {
      this.streetDataComp.streetData[this.keyName] = new AddressDetails();

      this.streetDataComp?.bindStreetData(this.hideAddress);
    }
  }

  // this uses for current location
  updateAddress(lat, lng) {
    this.addHeader();
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    let st = this.streetDataComp?.streetData[this.keyName];
    if (!st) {
      st = new AddressDetails();
    }
    if (!st.geometry || !st.geometry.coordinates) {
      st.geometry = {
        coordinates: [],
        type: MapDrawType.POINT
      };
    }
    st.geometry.coordinates[0] = lng;
    st.geometry.coordinates[1] = lat;
    if (this.streetDataComp) {
      this.streetDataComp.streetDataStr = JSON.stringify(st);
    }
    this.updateMap(lat, lng, true, true);

    if (this.mapGeo) { // use geocodeSearchService
      this.mapGeo.reverse([lng, lat]
        , (streetData) => {
          if (streetData) {
            st = streetData;
          }
          if (this.streetDataComp) {
            this.streetDataComp.streetDataStr = JSON.stringify(st);
          }
          this.updateChange();
        }
        , (err) => {
          console.log(`error = `, err);
          this.updateChange();
        });
    } else { // use default geo api
      const link = this.sclUtilMapService.getGeocodeCoordinate(this.geocodeURL, lat, lng, this.componentDefinition, this.apiKey);
      this.httpClient.get(link).subscribe(res => {
          const data = (res as any);
          if (data && data.geocoding_results.STATUS.status === 'SUCCESS') {
            const suggestions = data.geocoding_results.RESULTS[0];
            const address = suggestions.ADDRESS;
            st.properties.streetNo = address.street_number;
            st.properties.street = address.street_name;
            st.properties.suburb = address.locality;
            st.properties.postcode = address.postal_code;
            st.properties.country = address.country;
            st.properties.state = address.admin_1;
            st.geometry.coordinates[0] = lng;
            st.geometry.coordinates[1] = lat;
          }
          if (this.streetDataComp) {
            this.streetDataComp.streetDataStr = JSON.stringify(st);
          }
          this.updateChange();
        },
        error => {
          console.log(`Error : `, error);
          this.updateChange();
        });
    }
  }
  getHandlerValue(data) {
    const qualityRegex = /{{{?(.*?)?[a-z]+.[a-z]*}?}}/g;
    let matches;
    const qualities = [];

    while (matches = qualityRegex.exec(data)) {
      const match0 = matches[0];
      const item = match0.replace('{{{', '').replace('}}}', '');
      qualities.push(item);
    }

    return qualities;
  }


  async setSelectedAssetVisualize() {
    if (!this.mapFunc) { return; }
    for (let i = 0; i < this.mapFunc.visualizeSelectedAsset.length; i++) {
      const assetVisualize = this.mapFunc.visualizeSelectedAsset[i];
      await this.updateStoredSelectedAssetVisualize(assetVisualize.id,
        assetVisualize.handlebarsContext);
    }
  }

  async updateStoredSelectedAssetVisualize(id, handlebarsContext) {
    return new Promise( async (resolve, reject) => {
      try {
        await this.mapFunc.mapObj.updateStoredSelectedAssetVisualize(id, handlebarsContext, this.primaryIcon
          , cloneDeep(this.primaryAssetSelection), this.secondaryIcon
            , cloneDeep(this.secondaryAssetSelection), this.handlebarAsset.bind(this) );

        resolve(true);
      } catch (err) {
        reject(err);
      }
    });
  }

  createFeature(params) {
    
    const featureData = params.featureData;
    const type = params.type;
    const imageFileNo = params.imageFileNo;
    const name = params.name;
    const id = params.id;
    const color = params.color;
    const layerDisplayOnly = params.layerDisplayOnly;
    const anchor = params.anchor;
    // url
    const layerClone = params.layerClone;
    const tooltip = params.tooltip;
    const label = params.label;
    const layer = params.layer;
    const layerIndex = params.layerIndex;
    const centerPoint = params.centerPoint;
    const rotation = params.rotation;
    const scale = params.scale;
    // docId
    const radius = params.radius;
    const circleCenter = params.circleCenter;
    const handlebarsContext = params.handlebarsContext;
    const itemData = params.itemData;
    const primaryMultiPopup = params.primaryMultiPopup;
    const secondaryMultiPopup = params.secondaryMultiPopup;
    const asset = params.asset;
    const iRelatedAsset = params.iRelatedAsset;
    const sharedId = params.sharedId;

    const feature = this.mapFunc.mapObj.createFeatureByType(featureData.geometry.coordinates, type
      , {
          EPSG: this.mapFunc.EPSG,
          imageFileNo,
          name,
          id,
          color,
          layerDisplayOnly,
          anchor,
          url: null,
          primaryMultiPopup,
          secondaryMultiPopup,
          label,
          layerType: layer.type,
          layerIndex,
          centerPoint,
          rotation,
          scale,
          radius,
          circleCenter,
          layer: cloneDeep(layerClone),
          relatedAsset: iRelatedAsset,
          sharedId,
        });

    if (feature === null) {
      return null;
    }

    this.mapFunc.mapObj.setFeatureProperties(feature, {
      type: type, coorData: featureData.geometry.coordinates, itemData
    });
    if (this.componentDefinition.primaryAssetAddressSelection && asset && asset.street) {
      this.mapFunc.mapObj.setFeatureProperties(feature, {street: asset.street});
    }
    const fea = this.mapFunc.mapObj.getFeatureById(id);
    if (!fea) {
      this.mapFunc.mapObj.addFeature(feature, layerIndex);
      let hbObject;
      hbObject = {};
      hbObject.id = this.mapFunc.mapObj.getFeatureId(feature);
      hbObject.tooltips = layer.tooltips;
      hbObject.layerIndex = layerIndex;
      if (tooltip) { hbObject.tooltips = tooltip; }
      hbObject.handlebarsContext = handlebarsContext;
      hbObject.contextParams = this.mapFunc.contextParams;
      if (!find(this.mapFunc.tooltipHandleBarObjects, { id, layerIndex })) {
        this.mapFunc.tooltipHandleBarObjects.push(hbObject);
      }


      if (this.layersRedraw === true) {
          if (layerIndex in this.mapFunc.mapObj.assetOfLayers) {
            this.mapFunc.mapObj.assetOfLayers[layerIndex].push(feature);
          } else {
            this.mapFunc.mapObj.assetOfLayers[layerIndex] = [feature];
          }
      }
    }

    return feature;
  }

  async handlebarAsset(handlebarsContext, defaultIcon, assetSelectionObj, isPrimary) {
    let prefix = 'primary';
    if (!isPrimary) { prefix = 'secondary'; }
    let image = defaultIcon;
    let anchor = (assetSelectionObj.selectionImageAnchor ? assetSelectionObj.selectionImageAnchor : [0.5, 1]);
    let rotation = (assetSelectionObj.selectionImageRotation ? assetSelectionObj.selectionImageRotation : 0);
    let color = (assetSelectionObj.selectionColor ? assetSelectionObj.selectionColor: null);
    let fillColor = (assetSelectionObj.selectionFill ? assetSelectionObj.selectionFill: null);
    let fillOpacity = (assetSelectionObj.selectionFillOpacity ? assetSelectionObj.selectionFillOpacity: 1);
    let lineCap = ( assetSelectionObj.selectionLineCap ? assetSelectionObj.selectionLineCap: null);
    let lineDash = ( assetSelectionObj.selectionLineDash ? assetSelectionObj.selectionLineDash: null);
    let lineWidth = ( assetSelectionObj.selectionLineWidth ? assetSelectionObj.selectionLineWidth: null);
    if (this.mapFunc.disableHandlebars === false) {
      let imageBars = sclHandlebars.processHandlebars(assetSelectionObj.selectionImageFileNo, handlebarsContext
        , null, null, this.mapFunc.contextParams, null);
      image = imageBars;
      if (imageBars && isString(imageBars) && imageBars.indexOf('api/getFile') < 0) {
        image = await this.mapFunc.getIcon(imageBars);
      } else if(!image) {
        if (isPrimary) { image = SclMapConstantService.MAP_PRIMARY_ASSET; }
        else { image = SclMapConstantService.MAP_SECONDARY_ASSET; }
      }

      if (!(typeof assetSelectionObj.selectionImageAnchorHandlebars === 'undefined'
       || assetSelectionObj.selectionImageAnchorHandlebars === null)) {
        anchor = this.sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.mapFunc.contextParams,
          assetSelectionObj.selectionImageAnchor, assetSelectionObj.selectionImageAnchorHandlebars, handlebarsContext, 'array', null);
        if(!anchor) { anchor = [0.5, 1]; }
      }
      if (!(typeof assetSelectionObj.selectionImageRotationHandlebars === 'undefined'
       || assetSelectionObj.selectionImageRotationHandlebars === null)) {
        rotation = this.sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.mapFunc.contextParams,
            assetSelectionObj.selectionImageRotation, assetSelectionObj.selectionImageRotationHandlebars, handlebarsContext, 'float', null);
        if(!rotation) { rotation = 0; }
      }

      color = sclHandlebars.processHandlebars(assetSelectionObj.selectionColor, handlebarsContext, null, null, this.mapFunc.contextParams, null);
      if (!color) {
        if (isPrimary) { color = 'green';
        } else { color = 'black'; }
      }
      fillColor = sclHandlebars.processHandlebars(assetSelectionObj.selectionFill, handlebarsContext, null, null, this.mapFunc.contextParams, null);
      if (!fillColor) {
        if (isPrimary) { fillColor = 'green';
        } else { fillColor = 'black'; }
      }


      if (!(typeof assetSelectionObj.selectionFillOpacityHandlebars === 'undefined' || assetSelectionObj.selectionFillOpacityHandlebars === null)) {
        let fillOpacityBars = this.sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.mapFunc.contextParams,
          assetSelectionObj.selectionFillOpacity, assetSelectionObj.selectionFillOpacityHandlebars, handlebarsContext, 'float', null);
        if (fillOpacityBars) { fillOpacity = fillOpacityBars; }
      }

      if (!(typeof assetSelectionObj.selectionLineCapHandlebars === 'undefined' || assetSelectionObj.selectionLineCapHandlebars === null)) {
        let lineCapBars = this.sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.mapFunc.contextParams,
          assetSelectionObj.selectionLineCap, assetSelectionObj.selectionLineCapHandlebars, handlebarsContext, 'string', null);
        if (lineCapBars) { lineCap = lineCapBars; }
      }

      if (!(typeof assetSelectionObj.selectionLineDashHandlebars === 'undefined' || assetSelectionObj.selectionLineDashHandlebars === null)) {
        let lineDashBars = this.sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.mapFunc.contextParams,
          assetSelectionObj.selectionLineDash, assetSelectionObj.selectionLineDashHandlebars, handlebarsContext, 'array', null);
        if (lineDashBars) { lineDash = lineDashBars; }
      }

      if (!(typeof assetSelectionObj.selectionLineWidthHandlebars === 'undefined' || assetSelectionObj.selectionLineWidthHandlebars === null)) {
        let lineWidthBars = this.sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.mapFunc.contextParams,
          assetSelectionObj.selectionLineWidth, assetSelectionObj.selectionLineWidthHandlebars, handlebarsContext, 'int', null);
        if (lineWidthBars) { lineWidth = lineWidthBars; }
      }
    }
    const result = { image, anchor, rotation, color, fillColor, fillOpacity, lineCap, lineDash, lineWidth};
    return result;
  }



  removeAssetData(assets, id) {
    for (let i = 0; i < assets.length; i++) {
      const asset = assets[i];
      if (asset.properties.linkAssets[0].documentId === id) {
        assets.splice(i, 1);
        break;
      }
    }
  }
  removeAssetSelected(assetType, id) {
    if (id.indexOf('_') > -1) { id = id.split('_')[0]; }
    if (assetType === MapSelectAssetType.PRIMARY) {
      for (let i = this.primaryAssets.length - 1; i > -1 ; i--) {
        if (this.primaryAssets[i].id.indexOf(id) > -1) {
          this.primaryAssets.splice(i, 1);
        }
      }
    } else if (assetType === MapSelectAssetType.SECONDARY) {
      for (let i = this.secondaryAssets.length - 1; i > -1 ; i--) {
        if (this.secondaryAssets[i].id.indexOf(id) > -1) {
          this.secondaryAssets.splice(i, 1);
        }
      }
    }
    // remove street data for this asset
    if ( ( (assetType === MapSelectAssetType.PRIMARY && this.lookupAddressForPrimaryAsset)
     || (assetType === MapSelectAssetType.SECONDARY && this.lookupAddressForSecondaryAsset))
     && this.latestAssetId && this.latestAssetId.indexOf(id) > -1) {
      if (this.mapFunc && this.mapFunc.geoAutoComplete != null) {
        this.mapFunc.geoAutoComplete.removeStreet(this.keyName);
      }
      this.removeStreet();
      this.latestAssetId = null;
    }
  }
  removePrimaryAsset(item) {
    this.removeAsset(item, MapSelectAssetType.PRIMARY, this.assets.primary);
  }
  removeSecondaryAsset(item) {
    if (this.noSecondaryAssetSelection) { return; }
    this.removeAsset(item, MapSelectAssetType.SECONDARY, this.assets.secondary);
  }
  removeAsset(item, assetType, scopeAsset) {
    if (this.disabled) { return; }
    const docId = item.properties.linkAssets[0].documentId;
    const id = docId + '_' + assetType;
    if (id) {
      this.mapFunc.mapObj.removeSelectedAssetsById(id);
      if ((assetType === MapSelectAssetType.PRIMARY
         && this.primaryAssetSelectionMode === MapSelectAssetMode.POINT)
          || (assetType === MapSelectAssetType.SECONDARY
             && this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT)) {
        const f = this.mapFunc.mapObj.getFeatureById(id);
        if (f) {
          this.mapFunc.mapObj.removeFeature(f);
        }
      }
    }
    this.removeAssetData(scopeAsset, docId);

    this.removeAssetSelected(assetType, docId);

    // make dirty and remove selected icon
    this.updateValue();
    this.valueChanged(cloneDeep(this.mapFunc.featureCollections));
  }

  addHeader() {
    if (!this.mapFunc.featureCollections || !this.mapFunc.featureCollections.type) {
      const header = {
          type : GEOJSON_TYPE.FEATURE_COLLECTION,
          features: []
      };
      this.mapFunc.featureCollections = header;

    }
  }

  updateValue() {
    this.mapFunc.featureCollections.features = [];
    if (this.streetDataComp && this.streetDataComp.streetData
       && this.streetDataComp.streetData[this.keyName] ) {
      if (this.streetDataComp.streetData[this.keyName].properties
         && this.streetDataComp.streetData[this.keyName].properties.type !== MapSelectAssetType.STREET) {
        this.resetAddressData();
      };
      const st = cloneDeep(this.streetDataComp.streetData[this.keyName]);
      this.sclUtilMapService.streetDataRemoveEmpty(st);
      if (typeof (st.geometry) !== 'undefined' && st.geometry !== null) {
        st.geometry.type = MapDrawType.POINT;
      }
      if (this.sclUtilMapService.isValidPoint(st)) {
        this.mapFunc.featureCollections.features.push(st);
      }
    }
    if (this.assets) {
      if (this.assets.primary && this.assets.primary.length > 0) {
        if (this.primaryAssetSelectionMode === MapSelectAssetMode.POINT) {
          this.setDocDirtyAsset(this.assets.primary, null);
        } else { this.setDocDirtyAsset(this.assets.primary, this.primaryAssets); }
      }
      if (this.assets.secondary && this.assets.secondary.length > 0) {
        if (this.secondaryAssetSelectionMode === MapSelectAssetMode.POINT) {
          this.setDocDirtyAsset(this.assets.secondary, null);
        } else { this.setDocDirtyAsset(this.assets.secondary, this.secondaryAssets); }
      }
      this.mapFunc.featureCollections.features = this.removeDuplicates(this.mapFunc.featureCollections.features, true);
    }

  }
  // 15336#c59379
  fullScreenEvent(mapHeight, isFullScreen) {
    if(isFullScreen) {
      this.mapFunc.mapHeight = mapHeight;
    } else {
      this.mapFunc.mapHeight = this.calculateMapHeight(); // 15755
    }
    this.mapFunc.dismissPopover();

  }
  calculateMapHeight() {
    let height = 180;
    if (this.componentDefinition.heightNum && this.componentDefinition.heightNum > 0 && !isNaN(this.componentDefinition.heightNum)) {
      height = 180 * this.componentDefinition.heightNum;
      const docHeight = document.body.scrollHeight;
      if (height > (docHeight - 180)) {
          height = docHeight - 180;
      }
    } else {
        height = 180;
    }// 13916
    return height;
  }

  setTooltipRadioPosition(pixel1) {
    if (!this.mapFunc.mapCenter || !this.mapFunc.mapCenter.x || !this.mapFunc.mapCenter.y) {
      this.mapFunc.getMapSize();
    }
    this.isRadioPopupScroll = false;
    if (this.radioPopupInfo && this.radioPopupInfo.nativeElement) {
      this.radioPopupInfo.nativeElement.style.height = 'auto';
    }

    let featureLeftPos1 = pixel1[0];
    let featureTopPos1 = pixel1[1];

    // set the tooltip position
    let tooltipHorizontalPosition1;
    let tooltipVerticalPosition1;

    if (featureLeftPos1 < this.mapFunc.mapCenter.x) {
        tooltipHorizontalPosition1 = 'left';
        featureLeftPos1 -= 10;
    } else {
        tooltipHorizontalPosition1 = 'right';
        featureLeftPos1 += 25;
    }

    if (featureTopPos1 < this.mapFunc.mapCenter.y) {
        tooltipVerticalPosition1 = 'bottom';
        featureTopPos1 += 10;
    } else {
        tooltipVerticalPosition1 = 'top';
        featureTopPos1 -= 10;
    }


    const divInfo1Pos = this.mapFunc.divInfo1.nativeElement.getBoundingClientRect();
    let tipWidth = divInfo1Pos.width; let tipHeight = divInfo1Pos.height;
    if (tipWidth === 0) { tipWidth = 200; }
    if (tipHeight === 0) { tipHeight = 200; }
    let tipPos = { left: 0, top: 0};
    if (tooltipVerticalPosition1 === 'top') {
      if (tooltipHorizontalPosition1 === 'left') {
        tipPos = {
          left: featureLeftPos1 + 1,
          top: featureTopPos1 - tipHeight + 1
        };
      } else {// right
        tipPos = {
          left: featureTopPos1 - tipWidth + 1,
          top: featureTopPos1 - tipHeight + 1
        };
      }
    } else {// bottom
      if (tooltipHorizontalPosition1 === 'left') {
        tipPos = {
          left: featureLeftPos1 + 1,
          top: featureTopPos1 + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos1 - tipWidth + 1,
          top: featureTopPos1 + 1
        };
      }
    }

    this.mapFunc.infoRadioPosition.left = tipPos.left + 'px';
    this.mapFunc.infoRadioPosition.top = tipPos.top + 'px';

    // check overflow and update height for radio popup
    let height = this.mapFunc.mapHeight;
    let radioTop = tipPos.top;
    let radioPopupInfoOffsetHeight = 0;
    if (this.radioPopupInfo && this.radioPopupInfo.nativeElement) {
      radioPopupInfoOffsetHeight = this.radioPopupInfo.nativeElement.offsetHeight;
    }
    if (tipPos.top > 0) {
      height = tipPos.top + radioPopupInfoOffsetHeight;
      radioTop = tipPos.top;
    } else {
      height = pixel1[1] + radioPopupInfoOffsetHeight;
      radioTop = pixel1[1];
    }
    if (height > this.mapFunc.mapHeight) {
      const h = this.mapFunc.mapHeight - pixel1[1];
      if (this.radioPopupInfo && this.radioPopupInfo.nativeElement) {
        this.radioPopupInfo.nativeElement.style.height = h + 'px';
      }
      this.isRadioPopupScroll = true;
      this.mapFunc.infoRadioPosition.top = radioTop + 'px';
    }
    if (tipPos.left < 0) {
      this.mapFunc.infoRadioPosition.left = pixel1[0] + 'px';
    }
    this.cdRef.detectChanges();
  }

  currentLocationCheckBoxOnClick(locationFn) {
    if (this.disabled) { return; }
    this.allowSelectAsset = false;

    locationFn();
  }

  loadAsset(fromSource, isFirstLoad) {

    this.mapFunc.loadAsset(fromSource, isFirstLoad, {});

  }




  // 14781
  loadInitialMapView() {
    if ( !this.componentDefinition.visible || !this.mapFunc || !this.mapFunc.mapObj
       || !this.mapFunc.mapObj.isMapReady) { return; }
    const layersIndexFit = [];
    let hasDefaultCoord = false;
    if (this.initialMapView.length > 0) {
      this.isUpdateViewPort = true;
    } else {
      this.isUpdateViewPort = false;
    }
    if (this.initialMapView.indexOf('all') > -1) {
      hasDefaultCoord = true;
      if (this.assets && this.assets.primary && this.assets.primary.length > 0) {
        layersIndexFit.push(this.mapFunc.mapObj.layerIndexPrimary);
      }
      if (this.assets && this.assets.secondary && this.assets.secondary.length > 0) {
        layersIndexFit.push(this.mapFunc.mapObj.layerIndexSecondary);
      }
      if (layersIndexFit.length === 0) {
        this.mapFunc.mapObj.centerDefault();
      }
      if (this.streetDataComp && this.streetDataComp.streetData && this.streetDataComp.streetData[this.keyName]
        && this.streetDataComp.streetData[this.keyName].geometry) {
        if (layersIndexFit.length === 0) {
          const coords = this.streetDataComp.streetData[this.keyName].geometry.coordinates;
          if (coords && coords?.length === 2 && isNaN(coords[0]) === false && isNaN(coords[1]) === false ) {
            this.mapFunc.mapObj.zoomToLocation(coords[1], coords[0]);
          }
        } else {
          layersIndexFit.push(this.mapFunc.mapObj.layerIndexAddress);
        }
      } else if (this.fieldValue.features) {
        for (let i = 0; i < this.fieldValue.features; i++) {
          const asset = this.fieldValue.features[i];
          if (asset.properties.type === MapSelectAssetType.STREET) {
            if (asset.geometry && Array.isArray(asset.geometry.coordinates)
               && asset.geometry.coordinates.length == 2) {
              this.updateMap(asset.geometry.coordinates[1],
                asset.geometry.coordinates[0], false, true);
            }
          }
        }
      }
    } else {
      if (this.initialMapView.indexOf('primary') > -1) {
          if (this.assets && this.assets.primary && this.assets.primary.length > 0) {
            layersIndexFit.push(this.mapFunc.mapObj.layerIndexPrimary);
          }
      }
      if (this.initialMapView.indexOf('secondary') > -1) {
          if (this.assets && this.assets.secondary && this.assets.secondary.length > 0) {
              layersIndexFit.push(this.mapFunc.mapObj.layerIndexSecondary);
          }
      }
      if (this.initialMapView.indexOf('map') > -1) {
          if (layersIndexFit.length === 0) {
            this.mapFunc.mapObj.centerDefault();
          } else {
            hasDefaultCoord = true;
          }
      }
      if (this.initialMapView.indexOf('address') > -1) {
          if (layersIndexFit.length === 0) {
              if (this.streetDataComp && this.streetDataComp.streetData
                 && this.streetDataComp.streetData[this.keyName]
                 && this.streetDataComp.streetData[this.keyName].geometry) {
                  const coords: any = this.streetDataComp.streetData[this.keyName].geometry.coordinates;
                  if (coords && coords?.length === 2 && isNaN(coords[0]) === false && isNaN(coords[1]) === false ) {
                    // console.log(`%c**** zoom to location`, 'color:red');
                    this.mapFunc.mapObj.zoomToLocation(coords[1], coords[0]);
                  }
              }
          } else {
            layersIndexFit.push(this.mapFunc.mapObj.layerIndexAddress);
          }
      }
    }
    if (layersIndexFit.length > 0) {
      this.mapFunc.mapObj.fitLayers(layersIndexFit, hasDefaultCoord);
    }
    if (this.initialMapView.length > 0) {
      // console.log(`%c**** initialMapView, clamp zoom floor`, 'color:red');
      this.mapFunc.mapObj.clampZoomFloor();
    }
    this.initialMapView = []; // this function call one time when load comp first time , saved document first time
    if (this.mapLibName === MapLibraryName.GOOGLE) {
      this.isUpdateViewPort = false;
    }
  }

  // removed by 14781#c55330
  onTilesLoaded() {
    // 15141: google map can't trigger onMoveEnd when zoom map
    if (this.mapLibName === MapLibraryName.GOOGLE && (this.initialAssetLoading || this.hasSavedAsset)) {
      if (this.isMapReady == null) {
        this.isMapReady = setInterval( this.mapReady.bind(this), 200);
      }
    }
  }

  onMoveEnd(evt) {
    if (this.isUpdateViewPort) {
      this.isUpdateViewPort = false; // reset
      return;
    }
    if (this.isMapReady == null) {
      this.isMapReady = setInterval( this.mapReady.bind(this), 200);
    }
  }
  onMapWheelScroll(evt) {
    this.hasMapWheelScroll = true;
    this.mapFunc.subLabelTiming = "On-Map-Wheel-Scroll";
  }
  mapReady() {
    if (this.mapFunc.mapObj.isMapReady) {
      this.mapFunc.resetupTooltipUI();
      clearInterval(this.isMapReady);
      this.isMapReady = null; // reset
      if (this.mapLibName === MapLibraryName.ARC_GIS && !this.initialAssetLoadArc) {
        this.initialAssetLoadArc = true;
        return;
      }
      if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
        if (this.mapFunc?.hasMapDragging == true) {
          this.mapFunc.hasMapDragging = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else if (this.mapFunc.mapObj.hasClickButtonZoom == true) {
          this.mapFunc.mapObj.hasClickButtonZoom = false; // reset
          this.loadAsset('click zoom button & mapMoveEnd', false);
        } else if (this.mapFunc.hasResize === true) {
          this.mapFunc.hasResize = false; // reset
          this.loadAsset('has resize window & mapMoveEnd', false);
        } else if (this.hasMapWheelScroll) {
          this.hasMapWheelScroll = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else if(this.mapFunc.hasMapWrapperResize) {
          this.mapFunc.hasMapWrapperResize = false; // reset
          this.loadAsset(this.mapFunc.subLabelTiming + ' & mapMoveEnd', false);
        } else {
          console.log(`**** CASE : has "map move end" event but don\'t load asset`);
        }
      } else {
        this.hasSavedAsset = false;
        this.loadAsset('mapMoveEnd', false);
      }
      this.resetMapAction();
    }
  }
  resetMapAction() {
    this.mapFunc.subLabelTiming = 'Unknow-Source'; // reset
    this.mapFunc.hasMapDragging = false;
    this.mapFunc.mapObj.hasClickButtonZoom = false;
    this.mapFunc.hasResize = false;
    this.hasMapWheelScroll = false;
  }

  initLayers(isInit) {
    if (this.isMapReady == null) {
      this.isMapReady = setInterval(() => {
        if (this.mapFunc.mapObj.isMapReady) {
          this.mapFunc.resetupTooltipUI();
          clearInterval(this.isMapReady);
          this.isMapReady = null; // reset
          if (this.componentDefinition.layers) {
            if (this.mapFunc.requestId) {
              clearTimeout(this.mapFunc.requestId);
            }
            this.mapFunc.requestId = null;
            this.mapFunc.isRequesting = true;
            this.mapFunc.fitCoords(this.mapFunc.featureCollections?.features);
            this.loadAsset('initialAssetLoading = true', true); // 14870
            this.mapFunc.mapObj.mapMoveEnd(this.onMoveEnd.bind(this));
          } else {
            this.loadInitialMapView();
            this.mapFunc.mapObj.mapMoveEnd(this.onMoveEnd.bind(this));
          }
        }
      }, 200);
    }
  }
    // begin 14465
  searchSequence(index, layers, searchFunction) {
    if (index < layers.length && this.mapFunc.isRequesting) {
      const layer = layers[index];
      searchFunction(layer, () => {
          if (!this.mapFunc.isRequesting) { return; }
          index++;
          this.searchSequence(index, layers, searchFunction);
      });
    } else {
      this.mapFunc.isRequesting = false;
      this.loadInitialMapView();
    }
  }

  async initSelectedAssetInfo(assetSelectionMode, assetSelectionModeConfig, assetSelection, assetSelectionConfig
    , imageRotation,imageRotationHandlebars, imageAnchorHandlebars, imageAnchor
    , color, fillColor, fillOpacity, fillOpacityHandlebars, lineCap, lineCapHandlebars
    , lineDash, lineDashHandlebars, lineWidth, lineWidthHandlebars
    , globalIcon, iconConfig, globalIconAnchor, globalSelectionRows) {

    if (assetSelectionModeConfig) {
      assetSelectionMode = assetSelectionModeConfig.toLowerCase();
    }

    if (assetSelectionConfig) {
      if ( !(typeof assetSelectionConfig.selectionImageFileNo === 'undefined' || assetSelectionConfig.selectionImageFileNo === null)
       && isString(assetSelectionConfig.selectionImageFileNo) ) {
        globalIcon = assetSelectionConfig.selectionImageFileNo;
        assetSelection.selectionImageFileNo = assetSelectionConfig.selectionImageFileNo;
      }
      if ( !(typeof assetSelectionConfig.selectionImageAnchor === 'undefined' || assetSelectionConfig.selectionImageAnchor === null)
       && isArray(assetSelectionConfig.selectionImageAnchor) ) {
        if (!globalIconAnchor) { globalIconAnchor = assetSelectionConfig.selectionImageAnchor; }
        assetSelection.selectionImageAnchor = assetSelectionConfig.selectionImageAnchor;
      }
      if (!(typeof assetSelectionConfig.selectionImageAnchorHandlebars === 'undefined' || assetSelectionConfig.selectionImageAnchorHandlebars === null)
       && isString(assetSelectionConfig.selectionImageAnchorHandlebars)) {
        assetSelection.selectionImageAnchorHandlebars = assetSelectionConfig.selectionImageAnchorHandlebars;
      }
      if (!(typeof assetSelectionConfig.selectionImageRotation === 'undefined' || assetSelectionConfig.selectionImageRotation === null)
       && isNumber(assetSelectionConfig.selectionImageRotation)) {
        assetSelection.selectionImageRotation = assetSelectionConfig.selectionImageRotation;
      }
      if (!(typeof assetSelectionConfig.selectionImageRotationHandlebars === 'undefined' || assetSelectionConfig.selectionImageRotationHandlebars === null)
       && isString(assetSelectionConfig.selectionImageRotationHandlebars)) {
        assetSelection.selectionImageRotationHandlebars = assetSelectionConfig.selectionImageRotationHandlebars;
      }
      if (!(typeof assetSelectionConfig.selectionColor === 'undefined' || assetSelectionConfig.selectionColor === null)
       && isString(assetSelectionConfig.selectionColor)) {
        assetSelection.selectionColor = assetSelectionConfig.selectionColor;
      }
      if (!(typeof assetSelectionConfig.selectionFill === 'undefined' || assetSelectionConfig.selectionFill === null)
       && isString(assetSelectionConfig.selectionFill)) {
        assetSelection.selectionFill = assetSelectionConfig.selectionFill;
      }
      if (!(typeof assetSelectionConfig.selectionFillOpacity === 'undefined' || assetSelectionConfig.selectionFillOpacity === null)
       && isNumber(assetSelectionConfig.selectionFillOpacity) && assetSelectionConfig.selectionFillOpacity >= 0) {
        assetSelection.selectionFillOpacity = assetSelectionConfig.selectionFillOpacity;
      }
      if (!(typeof assetSelectionConfig.selectionFillOpacityHandlebars === 'undefined'
       || assetSelectionConfig.selectionFillOpacityHandlebars === null) && isString(assetSelectionConfig.selectionFillOpacityHandlebars)) {
        assetSelection.selectionFillOpacityHandlebars = assetSelectionConfig.selectionFillOpacityHandlebars;
      }

      if (!(typeof assetSelectionConfig.selectionLineCap === 'undefined' || assetSelectionConfig.selectionLineCap === null)
       && isString(assetSelectionConfig.selectionLineCap)) {
        assetSelection.selectionLineCap = assetSelectionConfig.selectionLineCap;
      }
      if (!(typeof assetSelectionConfig.selectionLineCapHandlebars === 'undefined'
       || assetSelectionConfig.selectionLineCapHandlebars === null) && isString(assetSelectionConfig.selectionLineCapHandlebars)) {
        assetSelection.selectionLineCapHandlebars = assetSelectionConfig.selectionLineCapHandlebars;
      }

      if (!(typeof assetSelectionConfig.selectionLineDash === 'undefined' || assetSelectionConfig.selectionLineDash === null)
       && isArray(assetSelectionConfig.selectionLineDash)) {
        assetSelection.selectionLineDash = assetSelectionConfig.selectionLineDash;
      }
      if (!(typeof assetSelectionConfig.selectionLineDashHandlebars === 'undefined'
       || assetSelectionConfig.selectionLineDashHandlebars === null) && isString(assetSelectionConfig.selectionLineDashHandlebars)) {
        assetSelection.selectionLineDashHandlebars = assetSelectionConfig.selectionLineDashHandlebars;
      }

      if (!(typeof assetSelectionConfig.selectionLineWidth === 'undefined' || assetSelectionConfig.selectionLineWidth === null)
       && isNumber(assetSelectionConfig.selectionLineWidth) && assetSelectionConfig.selectionLineWidth > 1) {
        assetSelection.selectionLineWidth = assetSelectionConfig.selectionLineWidth;
      }
      if (!(typeof assetSelectionConfig.selectionLineWidthHandlebars === 'undefined'
       || assetSelectionConfig.selectionLineWidthHandlebars === null) && isString(assetSelectionConfig.selectionLineWidthHandlebars)) {
        assetSelection.selectionLineWidthHandlebars = assetSelectionConfig.selectionLineWidthHandlebars;
      }

      if (!(typeof assetSelectionConfig.selectionRows === 'undefined'
      || assetSelectionConfig.selectionRows === null) && isNumber(assetSelectionConfig.selectionRows)) {
        globalSelectionRows = assetSelectionConfig.selectionRows;
        assetSelection.selectionRows = assetSelectionConfig.selectionRows;
      }
    }

    if (!(typeof iconConfig === 'undefined' || iconConfig === null) && isString(iconConfig)) {
      globalIcon = iconConfig;
      assetSelection.selectionImageFileNo = iconConfig;
    }

    if (!(typeof imageRotation === 'undefined' || imageRotation === null) && isNumber(imageRotation)) {
      assetSelection.selectionImageRotation = imageRotation;
    }
    if (!(typeof imageRotationHandlebars === 'undefined' || imageRotationHandlebars === null) && isString(imageRotationHandlebars)) {
      assetSelection.selectionImageRotationHandlebars = imageRotationHandlebars;
    }
    if (!(typeof imageAnchorHandlebars === 'undefined' || imageAnchorHandlebars === null) && isString(imageAnchorHandlebars)) {
      assetSelection.selectionImageAnchorHandlebars = imageAnchorHandlebars;
    }

    if (!(typeof imageAnchor === 'undefined' || imageAnchor === null) && isArray(imageAnchor)) {
      assetSelection.selectionImageAnchor = imageAnchor;
    }
    if (!(typeof color === 'undefined' || color === null) && isString(color)) {
      assetSelection.selectionColor = color;
    }
    if (!(typeof fillColor === 'undefined' || fillColor === null) && isString(fillColor)) {
      assetSelection.selectionFill = fillColor;
    }
    if (!(typeof fillOpacity === 'undefined' || fillOpacity === null) && isNumber(fillOpacity) && fillOpacity >= 0) {
      assetSelection.selectionFillOpacity = fillOpacity;
    }
    if (!(typeof fillOpacityHandlebars === 'undefined' || fillOpacityHandlebars === null) && isString(fillOpacityHandlebars)) {
      assetSelection.selectionFillOpacityHandlebars = fillOpacityHandlebars;
    }
    if (!(typeof lineCap === 'undefined' || lineCap === null) && isString(lineCap)) {
      assetSelection.selectionLineCap = lineCap;
    }
    if (!(typeof lineCapHandlebars === 'undefined' || lineCapHandlebars === null) && isString(lineCapHandlebars)) {
      assetSelection.selectionLineCapHandlebars = lineCapHandlebars;
    }

    if (!(typeof lineDash === 'undefined' || lineDash === null) && isArray(lineDash)) {
      assetSelection.selectionLineDash = lineDash;
    }
    if (!(typeof lineDashHandlebars === 'undefined' || lineDashHandlebars === null) && isString(lineDashHandlebars)) {
      assetSelection.selectionLineDashHandlebars = lineDashHandlebars;
    }

    if (!(typeof lineWidth === 'undefined' || lineWidth === null) && isNumber(lineWidth)) {
      assetSelection.selectionLineWidth = lineWidth;
    }
    if (!(typeof lineWidthHandlebars === 'undefined' || lineWidthHandlebars === null) && isString(lineWidthHandlebars)) {
      assetSelection.selectionLineWidthHandlebars = lineWidthHandlebars;
    }


    if (assetSelection.selectionImageFileNo) {
      try {
        assetSelection.selectionImageFileNo = await this.mapFunc.getIcon(assetSelection.selectionImageFileNo);

      } catch (err) {
        console.log(`error getFileResource : `, err.message);
      }
    }

    return { assetSelectionMode, assetSelection,  globalIcon, globalIconAnchor, globalSelectionRows };
  }


  // START INIT MAP
  async ngAfterViewInit() {
    this.cdRef.detectChanges();

    this.mapFunc.divInfo = this.divInfo;
    this.mapFunc.divInfo1 = this.divInfo1;
    this.mapFunc.divInfoCluster = this.divInfoCluster;

    this.mapFunc.registerMapWrapperChange(this.mapWrapper, this.onMoveEnd.bind(this),
      {
        setPrimaryScrollView: this.setPrimaryScrollView.bind(this),
        setSecondaryScrollView: this.setSecondaryScrollView.bind(this),
      }
    );



    this.spanPrimarySelection = $( document.querySelector( '#' + this.keyName + 'primarySelectRows' +
      (this.hideAddress ? '1' : '') + ' div div span' ) ); // 14327
    this.spanSecondarySelection = $( document.querySelector( '#' + this.keyName + 'secondarySelectRows' +
      (this.hideAddress ? '1' : '') + ' div div span' ) ); // 14327

    let googleKey = null;
    let defaultLat;
    let defaultLon;
    let defaultZoom;
    if (this.mapParameters) {
      defaultLat = this.mapParameters.defaultLat;
      defaultLon = this.mapParameters.defaultLon;
      defaultZoom = this.mapParameters.defaultZoom;
      if (this.mapParameters.mapViews) {
        for (let i = 0; i < this.mapParameters.mapViews.length; i++) {
          if (this.mapParameters.mapViews[i].serverType === MapLibraryName.GOOGLE) {
            this.mapLibName = MapLibraryName.GOOGLE;
            googleKey = (typeof this.mapParameters.mapViews[i].apiKey === 'undefined'
            || this.mapParameters.mapViews[i].apiKey === null) ? null : this.mapParameters.mapViews[i].apiKey;
            if (googleKey == null) { console.error('Google map key is null'); }
            break;
          }
        }
      } else {
        this.mapParameters.mapViews = SclMapConstantService.DEFAULT_MAP_PARAMETERS.mapViews;
      }
    } else {
      this.mapParameters = SclMapConstantService.DEFAULT_MAP_PARAMETERS;
    }
    // begin 14406
    if (this.mapLibName === MapLibraryName.GOOGLE) {
      this.mapFunc.maxZoomAsset = 20;
      this.mapFunc.minZoomAsset = 15;
    } else if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      this.mapFunc.maxZoomAsset = 16;
      this.mapFunc.minZoomAsset = 9;
    }
    if (this.componentDefinition.maxZoom) { this.mapFunc.maxZoomAsset = this.componentDefinition.maxZoom; }
    if (this.componentDefinition.minZoom) { this.mapFunc.minZoomAsset = this.componentDefinition.minZoom; }
    // end 14406

    const mapId = this.keyName + 'gblMap';
    const targetMap = document.getElementById(mapId);
    const divWrapper = document.getElementById(this.keyName + 'MapWrapper');
    this.mapFunc.targetMapElement = targetMap;


    // primary
    const pInfo = await this.initSelectedAssetInfo(this.primaryAssetSelectionMode
      , this.componentDefinition.primaryAssetSelectionMode
      , cloneDeep(this.primaryAssetSelection), this.componentDefinition.primaryAssetSelection
      , this.componentDefinition.primaryImageRotation, this.componentDefinition.primaryImageRotationHandlebars
      , this.componentDefinition.primaryImageAnchorHandlebars, this.componentDefinition.primaryImageAnchor
      , this.componentDefinition.primaryColor, this.componentDefinition.primaryFill
      , this.componentDefinition.primaryFillOpacity, this.componentDefinition.primaryFillOpacityHandlebars
      , this.componentDefinition.primaryLineCap, this.componentDefinition.primaryLineCapHandlebars
      , this.componentDefinition.primaryLineDash, this.componentDefinition.primaryLineDashHandlebars
      , this.componentDefinition.primaryLineWidth, this.componentDefinition.primaryLineWidthHandlebars
      , this.primaryIcon, this.componentDefinition.primaryImageFileNo, this.primaryImageAnchor
      , this.primarySelectionRows);
    this.primaryAssetSelectionMode = pInfo.assetSelectionMode;
    this.primaryAssetSelection = pInfo.assetSelection;
    this.primaryIcon = pInfo.globalIcon;
    this.primaryImageAnchor = pInfo.globalIconAnchor;
    this.primarySelectionRows = pInfo.globalSelectionRows;


    // secondary
    const sInfo = await this.initSelectedAssetInfo(this.secondaryAssetSelectionMode,
       this.componentDefinition.secondaryAssetSelectionMode
      , cloneDeep(this.secondaryAssetSelection), this.componentDefinition.secondaryAssetSelection
      , this.componentDefinition.secondaryImageRotation, this.componentDefinition.secondaryImageRotationHandlebars
      , this.componentDefinition.secondaryImageAnchorHandlebars, this.componentDefinition.secondaryImageAnchor
      , this.componentDefinition.secondaryColor, this.componentDefinition.secondaryFill
      , this.componentDefinition.secondaryFillOpacity, this.componentDefinition.secondaryFillOpacityHandlebars
      , this.componentDefinition.secondaryLineCap, this.componentDefinition.secondaryLineCapHandlebars
      , this.componentDefinition.secondaryLineDash, this.componentDefinition.secondaryLineDashHandlebars
      , this.componentDefinition.secondaryLineWidth, this.componentDefinition.secondaryLineWidthHandlebars
      , this.secondaryIcon, this.componentDefinition.secondaryImageFileNo, this.secondaryImageAnchor
      , this.secondarySelectionRows);
    this.secondaryAssetSelectionMode = sInfo.assetSelectionMode;
    this.secondaryAssetSelection = sInfo.assetSelection;
    this.secondaryIcon = sInfo.globalIcon;
    this.secondaryImageAnchor = sInfo.globalIconAnchor;
    this.secondarySelectionRows = sInfo.globalSelectionRows;

    // init map
    this.mapFunc.initLib(this.mapFunc, this.mapLibName , {googleKey}
      , async (mapObj) => {
      console.log(`****************** init map done ******************* `);
      this.isComponentReady = true;
      this.cdRef.detectChanges(); // to make isParentReady of geo-aut-complete updated
      this.mapFunc.mapObj = mapObj;

      this.mapFunc.multiLayers(this.mapParameters); // add multiple map views


      // add button pencil
      const addSelectAction = (element) => {
        const checkbox = this.sclMapViews.createCheckbox(document, this.keyName + 'Select');
        checkbox.onclick = () => {
          if (this.mapFunc && this.mapFunc.mapObj) {
            this.mapFunc.mapObj.compActionType = '';
          }
          this.setActive(false);
          this.isEditable = !this.isEditable;
          this.isSecondaryAsset = false;
          this.isPrimaryAsset = false;

          const secDoc: any = document.getElementById(this.keyName + 'Secondary');
          if (secDoc) {secDoc.checked = false; }
          const priDoc: any = document.getElementById(this.keyName + 'Primary');
          if (priDoc) {priDoc.checked = false; }
        };
        element.appendChild(checkbox);

        const iSpan = document.createElement('i');
        iSpan.setAttribute('class', 'material-icons');
        iSpan.innerHTML = 'mode_edit';

        const label =  this.sclMapViews.createLabel(document, this.keyName + 'Select', null);
        label.setAttribute('class', 'control-pencil');
        label.appendChild(iSpan);
        element.appendChild(label);

        this.mapFunc.pencilElements.push(checkbox);
        this.mapFunc.pencilElements.push(label);
      };


      // when click checkbox P
      const addPrimaryAction = (element) => {
        const checkbox = this.sclMapViews.createCheckbox(document, this.keyName + 'Primary');

        checkbox.onclick = () => {
            this.isPrimaryAsset = !this.isPrimaryAsset;
            this.allowSelectAsset = this.isPrimaryAsset;
            if (this.mapFunc && this.mapFunc.mapObj) {
              this.mapFunc.mapObj.compActionType = (this.isPrimaryAsset ? 'primary' : '');
            }
            this.setActive(this.isPrimaryAsset);
            this.isSecondaryAsset = false;
            this.isEditable = false;

            const secDoc: any = document.getElementById(this.keyName + 'Secondary');
            if (secDoc) {secDoc.checked = false; }
            const selDoc: any = document.getElementById(this.keyName + 'Select');
            if (selDoc) {selDoc.checked = false; }
          };

        element.appendChild(checkbox);
        const label =  this.sclMapViews.createLabel(document, this.keyName + 'Primary', '');
        const iSpan = document.createElement('span');
        iSpan.innerHTML = 'P';
        const css = { 'vertical-align': '-webkit-baseline-middle'};
        Object.assign(iSpan.style, css);

        label.appendChild(iSpan);

        element.appendChild(label);
      };
      // when click checkbox S
      const addSecondaryAction = (element) => {
        const checkbox = this.sclMapViews.createCheckbox(document, this.keyName + 'Secondary');
        checkbox.onclick = () => {
          this.isSecondaryAsset = !this.isSecondaryAsset;
          this.allowSelectAsset = this.isSecondaryAsset;
          if (this.mapFunc && this.mapFunc.mapObj) {
            this.mapFunc.mapObj.compActionType = (this.isSecondaryAsset ? 'secondary' : '');
          }
          this.setActive(this.isSecondaryAsset);
          this.isPrimaryAsset = false;
          this.isEditable = false;

          const selDoc: any = document.getElementById(this.keyName + 'Select');
          if (selDoc) {selDoc.checked = false; }
          const priDoc: any = document.getElementById(this.keyName + 'Primary');
          if (priDoc) {priDoc.checked = false; }
        };
        element.appendChild(checkbox);
        const label =  this.sclMapViews.createLabel(document, this.keyName + 'Secondary', '');
        const iSpan = document.createElement('span');
        iSpan.innerHTML = 'S';
        const css = { 'vertical-align': '-webkit-baseline-middle'};
        Object.assign(iSpan.style, css);

        label.appendChild(iSpan);
        element.appendChild(label);
      };

      const self = this;
      const ActionControl = function(ctrlOptions) {
        const options = ctrlOptions || {};
        const element = document.createElement('div');


        const controlElement = document.createElement('div');
        if (self.mapLibName === MapLibraryName.OPEN_LAYER) {
          controlElement.className = 'gg-control check-group select-action ol-control custom-control';
        } else if (self.mapLibName === MapLibraryName.ARC_GIS) {
          if (self.componentDefinition.heightNum > 1) { // 15383
            controlElement.className = 'gis-control check-group select-action ol-control custom-control gg-custom-control-left-center';
          } else {
            controlElement.className = 'gis-control check-group select-action ol-control custom-control';
          }
        } else {
          if (self.componentDefinition.heightNum > 1) { // 15383
            controlElement.className = 'check-group select-action ol-control custom-control gg-custom-control-left-center';
          } else {
            controlElement.className = 'check-group select-action ol-control custom-control';
          }
        }

        if (!self.hideAddress) { addSelectAction(controlElement); }
        addPrimaryAction(controlElement);
        if (!self.noSecondaryAssetSelection) {
          addSecondaryAction(controlElement);
        }
        self.mapFunc.addCurrentLocationCheckbox(self.keyName, controlElement);

        element.appendChild(controlElement);


        self.mapFunc.addMapViewControl(element, self.keyName, self.layerIds);
        self.mapFunc.mapObj.layersRedraw = this.layersRedraw;
        self.mapFunc.mapObj.layersRedrawCount = ( (self.componentDefinition.layers) ?
        self.componentDefinition.layers.length : 0 ) + ( (self.componentDefinition.filter) ? 1 : 0 );
        self.mapFunc.mapObj.addControl(this, element, options);
        self.mapFunc.mapObj.elementCtrl = controlElement;
        self.hasCustomControl = true;
      };
      this.mapFunc.mapObj.setupControl(ActionControl);
      this.controls.push(new ActionControl({}));



      await this.mapFunc.setupMap(this.mapFunc, {target: this.mapFunc.targetMapElement, disableMouseWheel : this.disableMouseWheel
          , divWrapper, defaultLon, defaultLat
          , defaultZoom, EPSG: this.mapFunc.EPSG
          , minResolution: this.mapParameters.minResolution, maxResolution: this.mapParameters.maxResolution
          , layerAssets : this.mapFunc.layerAssets
          , controls: this.controls, style: MapComponentName.SELECTED_ASSET
          , mapId
          // , onTilesLoaded: (this.mapLibName === MapLibraryName.GOOGLE ? this.onTilesLoaded.bind(this) : null ) // 14781#c55330 + 15141
          , addressImageAnchor: this.addressImageAnchor, primaryImageAnchor: this.primaryImageAnchor
          , secondaryImageAnchor: this.secondaryImageAnchor
          , primaryAssetSelection: cloneDeep(this.primaryAssetSelection)
          , secondaryAssetSelection: cloneDeep(this.secondaryAssetSelection)
          , heightNum : (this.componentDefinition.heightNum ? this.componentDefinition.heightNum : null)
          , zoomFloor: this.zoomFloor
          // , updateWatchFieldsObj: { updateWatchFieldsLayer: this.updateWatchFieldsLayer, layers: this.componentDefinition.layers
          // , layerAssets: this.layerAssets, searchLayerFunc: this.searchAssetLayer.bind(this)  } // 14164
          , watcherFunction: (doc) => {
            // 16772#0068539
            if (!isEqual(this.document, doc)) {
              this.document = doc;
              this.mapFunc.contextParams.doc = this.document;
            } else {
              console.log(`happenning watch document but new Value = old Value`);
            }
          }
          // , setupMapDone: (this.mapLibName === MapLibraryName.OPEN_LAYER ? null : this.initLayers.bind(this)) // 14870
          , componentDefinition : this.componentDefinition
          , configService: this.configService
          , watchDocFn: this.watchDocFn
          , toolTipOnFeatureHover: (e) => {
              this.mapFunc.tooltipOnFeatureHover(e, this.mapLibName);
            }
          , setupTooltipUI: this.mapFunc.setupTooltipUI.bind(this.mapFunc)
          , fullScreenEvent: this.fullScreenEvent.bind(this)
          , drawStartCluster: this.drawStart.bind(this)
          , drawEndCluster: this.drawEnd.bind(this)
          , clusterClick: this.clusterClick.bind(this) // 15251
          , onMapWheelScroll: this.onMapWheelScroll.bind(this)
          , intervalToolTipSetup: this.intervalToolTipSetup
          , countIntervalTooltipSetup: this.countIntervalTooltipSetup
          , hasCustomControl: this.hasCustomControl
          , tooltipInfo: this.tooltipInfo
          , cdRef: this.cdRef
      }, this.keyName);

      if (this.mapFunc.divInfo && this.mapFunc.divInfo.nativeElement) {
        this.mapFunc.divInfo.nativeElement.style.zIndex = this.mapFunc.mapObj.layerIndexTooltips;
      }
      if (this.mapFunc.divInfo1 && this.mapFunc.divInfo1.nativeElement) {
        this.mapFunc.divInfo1.nativeElement.style.zIndex = this.mapFunc.mapObj.layerIndexTooltips;
      }

      this.toolTipZIndex = this.mapFunc.mapObj.layerIndexTooltips;

      this.autoCompleteBox = document.getElementById(this.keyName + 'GeoAutoComplete');


      // logic for save document
      if (!this.fieldValue) {
        if (this.streetDataComp) {
          this.streetDataComp.streetData[this.keyName] = new AddressDetails();
        }
      } else if (this.fieldValue.features) {
        let hasPrimary = false; let hasSecondary = false; let hasAddress = false; // 14781
        this.isLoadSavedDocument = true;
        const doc = cloneDeep(this.fieldValue);
        const length = doc.features.length;
        for (let i = 0; i < length; i++) {
          const asset = cloneDeep(doc.features[i]);
          if (asset.properties.type === MapSelectAssetType.PRIMARY) {
            this.assets.primary.push(asset);
            hasPrimary = true;
          } else if (asset.properties.type === MapSelectAssetType.SECONDARY) {
            this.assets.secondary.push(asset);
            hasSecondary = true;
          } else if (asset.properties.type === MapSelectAssetType.STREET) {
            if (asset.geometry && Array.isArray(asset.geometry.coordinates)
               && asset.geometry.coordinates.length == 2) {
              this.updateMap(asset.geometry.coordinates[1],
                asset.geometry.coordinates[0], false, true);
            }
            if (this.streetDataComp) {
              this.streetDataComp.streetData[this.keyName] = asset;
              this.sclUtilMapService.checkStreetGeometryComponent(this.streetDataComp, this.keyName);
              this.resetPostionMandatory();
              if (this.streetDataComp && this.streetDataComp.streetData
                 && this.streetDataComp.streetData[this.keyName]
                && this.streetDataComp.streetData[this.keyName].geometry) {
               this.streetDataComp.bindStreetData(this.hideAddress);
              }
            }
            hasAddress = true;
          }
        }
        if (this.primaryAssetSelectionMode === MapSelectAssetMode.ASSET) {
          const astPrimary = this.removeDuplicates(this.assets.primary, null);
          this.assetsPrimary = JSON.stringify(astPrimary);
        } else { this.assetsPrimary = JSON.stringify(this.assets.primary); }
        if (this.secondaryAssetSelectionMode === MapSelectAssetMode.ASSET) {
          const astSecondary = this.removeDuplicates(this.assets.secondary, null);
          this.assetsSecondary = JSON.stringify(astSecondary);
        } else { this.assetsSecondary = JSON.stringify(this.assets.secondary); }

        if (this.streetDataComp && !this.streetDataComp?.streetData[this.keyName]) {
          this.streetDataComp.streetData[this.keyName] = new AddressDetails();
          this.streetDataComp.streetDataStr = JSON.stringify(SclMapConstantService.STREET);
        }

        this.isLoadSavedDocument = false;

        this.mapFunc.featureCollections = doc;

        if (!this.componentDefinition.initialMapView) {
          if (hasPrimary && this.initialMapView.indexOf('primary') < 0) { this.initialMapView.push('primary'); }
          if (hasSecondary && this.initialMapView.indexOf('secondary') < 0) { this.initialMapView.push('secondary'); }
          if (hasAddress && this.initialMapView.indexOf('address') < 0) { this.initialMapView.push('address'); }
          if (!hasPrimary && !hasSecondary && !hasAddress && this.initialMapView.indexOf('map') < 0) {
            this.initialMapView.push('map');
          }
        }
      }


      this.mapFunc.mapObj.mapClickEvent( this.onMapClickEvent.bind(this) ); // end map click event

      // 15828 : offline map
      this.primaryIcon = await this.mapFunc.getIcon(this.primaryIcon);
      this.secondaryIcon = await this.mapFunc.getIcon(this.secondaryIcon);
      this.addressMarker = await this.mapFunc.getIcon(this.addressMarker);
      this.primaryAssetSelection.selectionImageFileNo = this.primaryIcon;
      this.secondaryAssetSelection.selectionImageFileNo = this.secondaryIcon;

      const allowLoadAsset = (!this.mapFunc.disableProcessingOnLoad && this.initialAssetLoading) ? true : false;
      // console.log(`%c**** allowLoadAsset = ${allowLoadAsset}`, 'color:red');
      if (allowLoadAsset == false) {
        this.setPositionForAsset();
        if (this.isMapReady == null) {
          this.isMapReady = setInterval(async () => {
            if (this.mapFunc.mapObj.isMapReady) {
              this.mapFunc.resetupTooltipUI();
              clearInterval(this.isMapReady);
              this.isMapReady = null; // reset
              this.loadInitialMapView();
              this.mapFunc.mapObj.mapMoveEnd(this.onMoveEnd.bind(this));
              if (this.mapLibName === MapLibraryName.GOOGLE && this.hasSavedAsset) {
                this.onMoveEnd(null);
              }
            }
          }, 200);
        }
      } else {
        this.mapFunc.resetupTooltipUI();
        if (this.mapLibName === MapLibraryName.GOOGLE) {
          this.setPositionForAsset();
          
          this.mapFunc.mapObj.onTilesLoaded = this.onTilesLoaded.bind(this);
        }
        this.initLayers(true);
      }

      this.setActive(false); // remove interaction in init
      this.mapFunc.mapWatchStop();
      this.mapFunc.actionAfterMapReady(this.mapFunc.setFieldActivation(this.mapFunc.targetMapElement, this.disabled, this.layerIds));




// ** begin TO DO
    // let mapWatchStop = scope.$watch('map', function () {
    //   // stop the mapWatch because it only needs to be run once
    //   mapWatchStop();


    // });//end mapWatchStop
// ** end TO DO

      let visibleOldVal = this.componentDefinition.visible;
      const visibleSub = this.broadcastService.on('componentDefinition.visible').subscribe((newValue: boolean) => {
        // 11942#c40375: specified to 'tplItem.visible' watch function for show/hide of rules
        if (!isEqual(newValue, visibleOldVal)) {
          visibleOldVal = newValue;
          if (newValue) {
            $('#divSelectedAsset' + this.keyName).removeClass('ng-hide');
          }
        }
      });
      this.subs.add(visibleSub);




      this.mapFunc.mapObj.mapPointerMoveEvent( (evt) => {
        if (evt.dragging) {
          this.mapFunc.hasMapDragging = evt.dragging;
          if (this.mapFunc?.hasMapDragging) {
            this.mapFunc.subLabelTiming = "On-map-pointer-move-end";
          }
          return;
        }

        this.mapFunc.lastEvt = evt;
        if (!this.mapFunc.mouseStopInterval && (!this.mapFunc.focusPopup || !this.mapFunc.currentPopover)) {
          this.mapFunc.mouseStopInterval = setInterval(() => {
            this.mapFunc.hasMouseStopped(evt);
          }, 450);

        }
      });
      if (this.selection && this.selection.length > 0) {
        for (let i = 0; i < this.selection.length; i++) {
          const sel = this.selection[i];
          if (sel.name === MapSelectAssetType.PRIMARY) {
            this.primarySelection = sel;
            if (sel.imageFileNo) {
              this.primarySelection.imageFileNo = sel.imageFileNo;
            } else {
              this.primarySelection.imageFileNo = this.primaryIcon; }
            if (!sel.selectionType) { this.primarySelection.selectionType = 'multiple'; }
            if (!sel.uiLabel) { this.primarySelection.uiLabel = 'P'; }
          } else if (sel.name === MapSelectAssetType.SECONDARY) {
            this.secondarySelection = sel;
            if (sel.imageFileNo) {
              this.secondarySelection.imageFileNo = sel.imageFileNo;
            } else {
              this.secondarySelection.imageFileNo = this.secondaryIcon; }
            if (!sel.selectionType) { this.secondarySelection.selectionType = 'multiple'; }
            if (!sel.uiLabel) { this.secondarySelection.uiLabel = 'S'; }
          }
        }
      }

    }, this.changedDocumentService, this.subs, this.document); // finish init map

    $(this.mapFunc.targetMapElement).on('mouseleave', this.onMapMouseLeave.bind(this));
  }// end ngAfterInit

  onMapMouseLeave() {
    if (this.mapFunc.isPopoverOpen) {
      this.mapFunc.dismissPopover();
    }
  }

  onMapClickEvent(evt) {
    this.removeDraw();
    if (this.disabled) { return; }
    if (this.mapFunc.isPopoverOpen) {
      this.mapFunc.dismissPopover();
    }
    if (this.mapLibName === MapLibraryName.OPEN_LAYER) {
      this.mapFunc.displayFeatureInfo(this.mapFunc.mapObj.getEventByPixel(evt.originalEvent));
    } else {
      this.mapFunc.displayFeatureInfo(evt);
    }
    if (!this.isEditable && !this.isPrimaryAsset && !this.isSecondaryAsset) { return; }
    if (this.isEditable) {
      const lat = evt.latLng.lat;
      const lng = evt.latLng.lng;

      let st: any = new AddressDetails();
      st.geometry.coordinates[0] = lng;
      st.geometry.coordinates[1] = lat;

      if (this.streetDataComp) {
        this.streetDataComp.streetData[this.keyName] = new AddressDetails();
        this.streetDataComp.streetData[this.keyName].geometry.coordinates[0] = lng;
        this.streetDataComp.streetData[this.keyName].geometry.coordinates[1] = lat;
        this.streetDataComp.streetDataStr = JSON.stringify(st);
      }

      this.switchPrimaryAssetAddressLookUp(false);

      if (this.mapGeo != null ) {

        this.mapGeo.reverse( [lng, lat], this.onMapClickReverseCb.bind(this, st), this.onMapClickReverseErrorCb.bind(this));

      } else {
        console.log(`Can\'t get address because reverse service is NULL`);
      }
    }
  }
  onMapClickReverseCb(st, streetData) {
    this.mapFunc.hasMapDragging = true;
    this.mapFunc.subLabelTiming = 'Get-Street-Data-By-Click-To-Map'
    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
    if (streetData == null) { return; }

    this.getRelatedDocument(streetData);
    st = streetData;
    if (this.streetDataComp) {
      this.streetDataComp.streetData[this.keyName] = streetData;
      this.streetDataComp.streetDataStr = JSON.stringify(st);
    }
    this.hasAddressPin = true;

    this.updateChange();
    this.resetPostionMandatory();
  }
  onMapClickReverseErrorCb(err) {
    this.removeRelatedDocument();

    this.clickPoint = null; // 14502
    this.primaryAssetAddressLookupClickPoint = null; // 15393
    console.log(`error = `, err);
    if (err && this.mapFunc.isOnline === true) {
      this.notificationService.error(err);
    }
    this.updateChange();
  }

  watchVisible(newValue, oldValue) {
    if (oldValue !== newValue) {
        if (newValue) {
            $('#divSelectedAsset' + this.fieldName + this.key).removeClass('ng-hide');
        }
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }

  valueChanged(value) {
    if (value && value.features && value.features.length == 0) {
      value = null;
    }
    if (!isEqual(this.fieldValue, value)) {

      super.valueChanged(value);

      this.assetsPrimary = JSON.stringify(this.assets.primary);
      this.assetsSecondary = JSON.stringify(this.assets.secondary);
    }
  }

  watchDocFn() {
    return this.fieldValue;
  }

  // begin logic for geo-auto-complete
  initGeoAutoComplete(e) {
    this.mapFunc.geoAutoComplete = e.geoAutoComplete;
    this.mapGeo = this.mapFunc.geoAutoComplete.mapGeo;
    this.mapFunc.isDisableAddressEntry = this.mapFunc.geoAutoComplete.isDisableAddressEntry;
  }
  // end logic for geo-auto-complete






  clusterClick(markers, pixel) {
    if (markers.length > 1) {
      this.clusterMarkersClicked = markers;
      this.getHTMLClusterMarkers(markers);
      this.setPopupClusterPosition(pixel);
    } else {
      // TO DO : go to normal select asset workflow
    }
  }
  setPopupClusterPosition(pixel1) {
    if (!this.mapFunc.mapCenter || !this.mapFunc.mapCenter.x || !this.mapFunc.mapCenter.y) {
      this.mapFunc.getMapSize();
    }
    this.isClusterPopupScroll = false;
    if (this.clusterPopupInfo && this.clusterPopupInfo.nativeElement) {
      this.clusterPopupInfo.nativeElement.style.height = 'auto';
    }

    let featureLeftPos1 = pixel1[0];
    let featureTopPos1 = pixel1[1];

    // set the tooltip position
    let tooltipHorizontalPosition1;
    let tooltipVerticalPosition1;

    if (featureLeftPos1 < this.mapFunc.mapCenter.x) {
        tooltipHorizontalPosition1 = 'left';
        featureLeftPos1 -= 10;
    } else {
        tooltipHorizontalPosition1 = 'right';
        featureLeftPos1 += 25;
    }

    if (featureTopPos1 < this.mapFunc.mapCenter.y) {
        tooltipVerticalPosition1 = 'bottom';
        featureTopPos1 += 10;
    } else {
        tooltipVerticalPosition1 = 'top';
        featureTopPos1 -= 10;
    }


    let tipWidth = 0; let tipHeight = 0;
    if (this.mapFunc.divInfoCluster && this.mapFunc.divInfoCluster.nativeElement) {
      const divClusterPos = this.mapFunc.divInfoCluster.nativeElement.getBoundingClientRect();
      tipWidth = divClusterPos.width;
      tipHeight = divClusterPos.height;
    }
    if (tipWidth === 0) { tipWidth = 200; }
    if (tipHeight === 0) { tipHeight = 200; }
    let tipPos = { left: 0, top: 0};
    if (tooltipVerticalPosition1 === 'top') {
      if (tooltipHorizontalPosition1 === 'left') {
        tipPos = {
          left: featureLeftPos1 + 1,
          top: featureTopPos1 - tipHeight + 1
        };
      } else {// right
        tipPos = {
          left: featureTopPos1 - tipWidth + 1,
          top: featureTopPos1 - tipHeight + 1
        };
      }
    } else {// bottom
      if (tooltipHorizontalPosition1 === 'left') {
        tipPos = {
          left: featureLeftPos1 + 1,
          top: featureTopPos1 + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos1 - tipWidth + 1,
          top: featureTopPos1 + 1
        };
      }
    }

    this.mapFunc.infoClusterPosition.left = tipPos.left + 'px';
    this.mapFunc.infoClusterPosition.top = tipPos.top + 'px';

    // check overflow and update height for radio popup
    let height = this.mapFunc.mapHeight;
    let clusterTop = tipPos.top;
    let clusterPopupInfoOffsetHeight = 0;
    if (this.clusterPopupInfo && this.clusterPopupInfo.nativeElement) {
      clusterPopupInfoOffsetHeight = this.clusterPopupInfo.nativeElement.offsetHeight;
    }
    if (tipPos.top > 0) {
      height = tipPos.top + clusterPopupInfoOffsetHeight;
      clusterTop = tipPos.top;
    } else {
      height = pixel1[1] + clusterPopupInfoOffsetHeight;
      clusterTop = pixel1[1];
    }
    if (height > this.mapFunc.mapHeight) {
      const h = this.mapFunc.mapHeight - pixel1[1];
      if (this.clusterPopupInfo && this.clusterPopupInfo.nativeElement) {
        this.clusterPopupInfo.nativeElement.style.height = h + 'px';
      }
      this.isClusterPopupScroll = true;
      this.mapFunc.infoClusterPosition.top = clusterTop + 'px';
    }
    if (tipPos.left < 0) {
      this.mapFunc.infoClusterPosition.left = pixel1[0] + 'px';
    }
    this.cdRef.detectChanges();
  }
  getHTMLClusterMarkers(features) {
    if (features === undefined || features.length === 0) {
      return;
    }

    this.clusterList = [];
    let isDisplayOnly = true;
    let currentAssets;
    if (this.isPrimaryAsset) {
      currentAssets = this.assets.primary;
    } else if (this.isSecondaryAsset) {
      currentAssets = this.assets.secondary;
    }
    for (let i = 0; i < features.length; i++) {
      const feature = features[i];
      const properties = this.mapFunc.mapObj.getFeatureProperties(feature, ['name', 'id', 'layerDisplayOnly', 'url']);
      const name = properties.name;
      const docId = properties.id;
      const exist = this.mapFunc.isContainFeature(docId, currentAssets);
      let check = '';
      if (exist) {
        check = 'checked';
      }
      const id = this.keyName + i + 'cluster';
      const cbName = this.keyName + 'cluster';
      let html = '';
      if (this.isPrimaryAsset) {
        if (!properties.layerDisplayOnly) {
          isDisplayOnly = false;
          if (this.singlePrimaryAssetSelection) {
            html += '<input type=\'radio\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
          } else {
            html += '<input type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>'; }
        }
        html += name;
      } else if (this.isSecondaryAsset) {
        if (!properties.layerDisplayOnly) {
          isDisplayOnly = false;
          if (this.singleSecondaryAssetSelection) {
            html += '<input type=\'radio\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
          } else {
            html += '<input type=\'checkbox\' ' + check + ' value = \'' + docId + '\'  name=\'' + cbName + '\' id = ' + id + '>';
          }
        }
        html += name;
      } else {
        html += '<span id =  \'' + docId + '\'>' + name + '</span>';
      }

      this.allowSelectAsset = isDisplayOnly;

      this.clusterList.push(html);
    }


    this.mapFunc.showPopupClusters();
    this.cdRef.detectChanges();
  }

  closeClusterPopup(isMultiMode) {
    if (isMultiMode) {
      const id = this.keyName + 'cluster';
      const assets = []; const selectedFeatures = [];
      const selectedAssetIds = [];
      const unSelectedAssetIds = [];
      const assetsCoord = [];
      const coor = this.mapFunc.mapObj.getLatLngFromPixel(this.mapFunc.pixelPopup);
      let street = null;
      let feaType = MapDrawType.LINE_STRING;

      const cboxes = document.getElementsByName(id);
      const len = cboxes.length;
      for (let i = 0; i < len; i++) {
        const iCb = cboxes[i] as HTMLInputElement;
        if (iCb.checked) {
          selectedAssetIds.push(iCb.value);
        } else {
          unSelectedAssetIds.push(iCb.value);
        }
      }
      for (let i = 0; i < selectedAssetIds.length; i++) {
        const fea = this.mapFunc.mapObj.getFeatureById(selectedAssetIds[i]);
        if (fea) {
          let type = MapSelectAssetType.PRIMARY;
          const pro = this.mapFunc.mapObj.getFeatureProperties(fea, ['street', 'type', 'coorData']);
          street = pro.street;
          feaType = pro.type;
          if (feaType === MapDrawType.POINT) {
            const loc = pro.coorData;
            assetsCoord.push(loc) ;
          } else {
            assetsCoord.push(coor);
          }

          if (this.isSecondaryAsset) {type = MapSelectAssetType.SECONDARY; }
          const asset = this.mapFunc.mapObj.getAssetProperties(fea, this.componentDefinition.relatedFields, assetsCoord[i], type);
          if (!asset) {return; }

          assets.push(asset);
          selectedFeatures.push( { feature: fea} );
        }
      }
      const options = { clickFeature: selectedFeatures, pixel: null, isClickMap: false };

      if (this.isPrimaryAsset) {
        this.selectPrimaryAction(assets, unSelectedAssetIds, assetsCoord, this.singlePrimaryAssetSelection, street, options);
      } else if (this.isSecondaryAsset) {
        this.selectSecondaryAction(assets, unSelectedAssetIds, assetsCoord, this.singleSecondaryAssetSelection, street, options);
      }
      this.clusterList = []; // reset
    }
    this.mapFunc.isPopupClusterOpen = false;
    this.mapFunc.infoClusterPosition = {left: '0px', top: '0px'};
    this.cdRef.detectChanges();
  }

  // 15393
  reverseAssetAddressLookup(lat, lng, id) {
    this.latestAssetId = null; // reset, fix when remove assetAddressLookup from related field don't remove street data of address
    let st = new AddressDetails();
    if (this.streetDataComp) {
      this.streetDataComp.streetData[this.keyName] = new AddressDetails();
      this.streetDataComp.streetDataStr = JSON.stringify(st);
    }

    if (this.mapGeo) {
      this.mapGeo.reverse( [lng, lat], (streetData, latLng) => {
        this.clickPoint = null;//14502
        this.latestAssetId = null; // reset
        this.primaryAssetAddressLookupClickPoint = null; // 15393
        if(streetData == null) return;
        this.getRelatedDocument(streetData);

        streetData.geometry.coordinates[0] = latLng.lng;
        streetData.geometry.coordinates[1] = latLng.lat;

        st = streetData;
        if (this.streetDataComp) {
          this.streetDataComp.streetData[this.keyName] = streetData;
          this.streetDataComp.streetDataStr = JSON.stringify(st);
        }
        this.mapFunc.mapObj.updateLocation(latLng.lat, latLng.lng, this.mapFunc.addressId, this.addressMarker
          , 'address', this.mapFunc.addressId, true);
        this.updateChange();
        this.resetPostionMandatory();
      }
      , (err) => {
        this.clickPoint = null;//14502
        this.primaryAssetAddressLookupClickPoint = null; // 15393
        console.info('error = ' + err);
        if (err && this.mapFunc.isOnline === true) {
          this.notificationService.error(err);
        }
        this.updateChange();
      });
    } else {
      console.log(`Can\'t get address because reverse service is NULL`);
    }
  }
  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    tooltip.toggle();
  }

  getRelatedDocument(streetData) {
    if (streetData.objRelated) {
      const documentListId = this.formParameters.unsavedDocumentListId;
      let hasUpdate = false;
      for (const field in streetData.objRelated) {
        if (streetData.objRelated.hasOwnProperty(field)) {
          const value = streetData.objRelated[field];
          this.document[field] = value;
          const cloneComp = cloneDeep(this);
          cloneComp.fieldName = field;
          hasUpdate = true;
        }
      }
      if (hasUpdate) {
        this.unsavedDocumentService.addDocumentToUnsavedList(this.document, documentListId);
      }
    }
    delete streetData.objRelated;
  }

  removeRelatedDocument() {
    let hasUpdate = false;
    const documentListId = this.formParameters.unsavedDocumentListId;
    for (const field in this.geoRelatedDocuments) {
      if (this.geoRelatedDocuments.hasOwnProperty(field) && this.document.hasOwnProperty(field) ) {
        delete this.document[field];
        hasUpdate = true;
      }
    }
    if (hasUpdate) {
      this.unsavedDocumentService.addDocumentToUnsavedList(this.document, documentListId);
    }
  }



  resetPostionMandatory() {
    if (this.positionMandatory) {
      if (this.streetDataComp) {
        this.streetDataComp.disableMandatory = false;
      }
      this.cdRef.detectChanges();
    }
  }

  trackByIdPrimary(index: any, pri: any) {
    return pri.properties.linkAssets[0].documentId;
  }
  trackByIdSecondary(index: any, snd: any) {
    return snd.properties.linkAssets[0].documentId;
  }

  // street-data events
  onStreetDataComponentInit(e) {
    this.streetDataComp = e.streetDataComp;
    if (this.positionMandatory) {
      this.streetDataComp.disableMandatory = true;
      this.streetDataComp.disableCoordinate = true;
      this.cdRef.detectChanges();
    }
    if (this.hasOnFieldValueChange) {
      this.streetDataComp.streetDataStr = JSON.stringify(this.streetDataInit);
      this.hasOnFieldValueChange = false; // reset
      this.streetDataInit = null; // reset
    }
  }
  onSetStreetDataStr() {
    this.addHeader();
    this.updateValue();
    this.isDocFieldValueChanged = false;
    this.streetDataComp?.bindStreetData(this.hideAddress);
  }
  onPropertyValueChange() {
    this.updateChange();
  }
  onValueChangedAddress() {
    this.updateChange();
  }
  onCoordinateValueChange() {
    this.valueChanged(cloneDeep(this.mapFunc.featureCollections));
  }
}
